/**
 * MeinGeschenk – Live-Gravur-Editor auf der Shopify-Produktseite.
 *
 * Lädt die im Admin gesetzte Konfiguration (Produktbild + Regionen/Zonen + Preise)
 * aus der App und lässt den Kunden live personalisieren: Text tippen / Foto hochladen,
 * das per 4-Punkt-Homographie (CSS matrix3d) passgenau – auch schräg – aufs Produkt-
 * bild gelegt wird. Denselben Warp nutzt das Panel; so sehen Händler und Kunde dasselbe.
 *
 * Preise/Regeln/Zeiten rechnet der Server (eine Wahrheit). Hinweis: Aufpreise sind bei
 * Shopify nur Angaben auf der Bestellung – der Checkout verrechnet den Artikelpreis.
 */
(function () {
  'use strict';
  function mgT(value, params) { return window.MGEditorI18n ? window.MGEditorI18n.text(value, params) : value; }
  function mgLabel(value, item, field) { return window.MGEditorI18n ? window.MGEditorI18n.label(value, item, field) : value; }
  function mgHTML(value) { return window.MGEditorI18n ? window.MGEditorI18n.html(value) : value; }
  function mgError(value) { return window.MGEditorI18n ? window.MGEditorI18n.error(value) : value; }
  // API display labels are translated; keep canonical names for order properties.
  function mgCanonicalConfig(value) {
    if (!value || typeof value !== 'object') return value;
    Object.keys(value).forEach(function (key) {
      if (key !== 'translations' && key !== 'sourceLabels') mgCanonicalConfig(value[key]);
    });
    Object.keys(value.sourceLabels || {}).forEach(function (key) {
      if (key === 'label' || key === 'name' || key === 'sample' || key === 'info' || key === 'markerLabel') value[key] = value.sourceLabels[key];
    });
    return value;
  }
  const mgEscape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));


  var APP_URL = (window.MEINGESCHENK_APP_URL || 'https://app.meingeschenk.ch').replace(/\/$/, '');

  // ---- Homographie: Rechteck auf 4 Zielpunkte ziehen (aus dem Panel portiert) ----
  function adj(m) {
    return [
      m[4] * m[8] - m[5] * m[7], m[2] * m[7] - m[1] * m[8], m[1] * m[5] - m[2] * m[4],
      m[5] * m[6] - m[3] * m[8], m[0] * m[8] - m[2] * m[6], m[2] * m[3] - m[0] * m[5],
      m[3] * m[7] - m[4] * m[6], m[1] * m[6] - m[0] * m[7], m[0] * m[4] - m[1] * m[3]
    ];
  }
  function multmm(a, b) {
    var c = [];
    for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) {
      var s = 0; for (var k = 0; k < 3; k++) s += a[3 * i + k] * b[3 * k + j];
      c[3 * i + j] = s;
    }
    return c;
  }
  function multmv(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  }
  function basisToPoints(p) {
    var m = [p[0][0], p[1][0], p[2][0], p[0][1], p[1][1], p[2][1], 1, 1, 1];
    var v = multmv(adj(m), [p[3][0], p[3][1], 1]);
    return multmm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
  }
  function projection(src, dst) { return multmm(basisToPoints(dst), adj(basisToPoints(src))); }
  function matrix3dFor(baseW, baseH, dst) {
    var src = [[0, 0], [baseW, 0], [baseW, baseH], [0, baseH]];
    var H = projection(src, dst);
    for (var i = 0; i < 9; i++) H[i] = H[i] / H[8];
    var m = [H[0], H[3], 0, H[6], H[1], H[4], 0, H[7], 0, 0, 1, 0, H[2], H[5], 0, H[8]];
    return 'matrix3d(' + m.join(',') + ')';
  }

  var FONTS = {
    elegant: '"Georgia","Times New Roman",serif', klassisch: '"Times New Roman",Georgia,serif',
    modern: '"Helvetica Neue",Arial,sans-serif', handschrift: '"Segoe Script","Brush Script MT","Comic Sans MS",cursive',
    schreibschrift: '"Lucida Handwriting","Apple Chancery",cursive', fett: '"Arial Black","Helvetica Neue",sans-serif',
    schmal: '"Arial Narrow","Helvetica Neue Condensed",sans-serif', schreibmaschine: '"Courier New",monospace'
  };
  var FONT_LABELS = {
    elegant: mgT("Elegant"), klassisch: mgT("Klassisch"), modern: mgT("Modern"), handschrift: mgT("Handschrift"),
    schreibschrift: mgT("Schreibschrift"), fett: mgT("Fett"), schmal: mgT("Schmal"), schreibmaschine: mgT("Schreibmaschine")
  };

  function money(currency, value) { return currency + ' ' + (Number(value) || 0).toFixed(2); }

  /** Kleines „Pflicht"-Abzeichen neben einer Feldbeschriftung. */
  function reqBadge() {
    return node('span', {
      style: 'display:inline-block;margin-left:7px;font-size:10px;font-weight:800;letter-spacing:.04em;'
        + 'color:#c0392b;background:#fdecea;border:1px solid #f3cfcc;border-radius:999px;'
        + 'padding:1px 8px;vertical-align:middle;text-transform:uppercase'
    }, [mgT("Pflicht")]);
  }

  function node(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'style') n.style.cssText = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  /**
   * Externe SVGs werden als farbige Maske dargestellt. Safari auf iPhone verwirft
   * eine domainuebergreifende Maske jedoch teilweise, wenn der Webserver den
   * CORS-Header noch nicht ausgeliefert oder ein alter Cache-Eintrag ihn nicht hat.
   * Das normale IMG darunter bleibt in diesem Fall sichtbar. Bei funktionierender
   * Maske liegt die exakt gleiche Form darueber und nimmt weiterhin z.color an.
   */
  function graphicPreviewNode(url, color) {
    var engravingColor = color || '#1a1a1a';
    var wrap = node('div', { style: 'position:relative;width:100%;height:100%;overflow:hidden' });
    var light = /^#(?:fff|ffffff)$/i.test(engravingColor) || /^white$/i.test(engravingColor);
    var fallback = node('img', {
      src: url,
      alt: '',
      draggable: 'false',
      style: 'position:absolute;inset:0;width:100%;height:100%;display:block;object-fit:contain;pointer-events:none;'
        + 'filter:brightness(0)' + (light ? ' invert(1)' : '')
    });
    var mask = node('div', {
      style: 'position:absolute;inset:0;width:100%;height:100%;background-color:' + engravingColor
    });
    var maskImage = 'url("' + String(url).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")';
    mask.style.webkitMaskImage = maskImage;
    mask.style.webkitMaskPosition = 'center';
    mask.style.webkitMaskRepeat = 'no-repeat';
    mask.style.webkitMaskSize = 'contain';
    mask.style.maskImage = maskImage;
    mask.style.maskPosition = 'center';
    mask.style.maskRepeat = 'no-repeat';
    mask.style.maskSize = 'contain';
    wrap.appendChild(fallback);
    wrap.appendChild(mask);

    return wrap;
  }

  function openPhotoPreview(src) {
    if (!src) return;
    var previous = document.getElementById('mg-photo-preview-dialog');
    if (previous) previous.remove();
    var close = function () { var dialog = document.getElementById('mg-photo-preview-dialog'); if (dialog) dialog.remove(); };
    var overlay = node('div', { id: 'mg-photo-preview-dialog', role: 'dialog', 'aria-modal': 'true', 'aria-label': mgT("Foto-Vorschau"), style: 'position:fixed;inset:0;z-index:9999;display:grid;place-items:center;padding:24px;background:rgba(25,18,15,.72);cursor:zoom-out' });
    var image = node('img', { src: src, alt: mgT("Dein hochgeladenes Foto"), style: 'display:block;max-width:min(92vw,760px);max-height:82vh;border-radius:14px;background:#fff;box-shadow:0 18px 60px rgba(0,0,0,.4);object-fit:contain;cursor:default' });
    var closeButton = node('button', { type: 'button', 'aria-label': mgT("Vorschau schliessen"), style: 'position:absolute;top:18px;right:18px;width:40px;height:40px;border:0;border-radius:50%;background:#fff;color:#222;font-size:28px;line-height:1;cursor:pointer' }, ['×']);
    overlay.addEventListener('click', function (event) { if (event.target === overlay) close(); });
    closeButton.addEventListener('click', close);
    overlay.appendChild(image);
    overlay.appendChild(closeButton);
    document.body.appendChild(overlay);
  }

  /**
   * Ein Positionsmerkmal setzen, ohne je ein bestehendes zu überschreiben.
   * Kollidiert ein Name trotz Seiten-Präfix (zwei gleich benannte Felder auf
   * derselben Seite), bekommt er eine Nummer – lieber „Name 2" als eine
   * verlorene Kundeneingabe. Gibt den tatsächlich verwendeten Namen zurück.
   */
  function putProp(props, name, value) {
    var n = name, i = 2;
    while (props[n] !== undefined) { n = name + ' ' + i; i++; }
    props[n] = value;

    return n;
  }

  // Styles für den Foto-Guide einmal einspielen (kompakt, an den alten Editor angelehnt).
  function injectGuideStyles() {
    if (document.getElementById('mg-fg-styles')) return;
    var css = ''
      + '.mg-fg{border:1px solid rgba(0,0,0,.14);border-radius:10px;overflow:hidden;margin-top:8px}'
      + '.mg-fg__sum{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:10px 12px;cursor:pointer;font-weight:700;font-size:13px;list-style:none}'
      + '.mg-fg__sum::-webkit-details-marker{display:none}'
      + '.mg-fg__chev{flex:none;width:8px;height:8px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);transition:transform .2s ease}'
      + '.mg-fg[open] .mg-fg__chev{transform:rotate(-135deg)}'
      + '.mg-fg__body{padding:0 12px 12px;font-size:12.5px;color:#555}'
      + '.mg-fg__text>*{margin:0 0 6px}.mg-fg__text>*:last-child{margin-bottom:0}'
      + '.mg-fg__text ul{padding-left:18px}'
      // Untereinander: pro Box erst das Bild, darunter der Text – liest sich auf dem Handy besser.
      + '.mg-fg__boxes{display:grid;grid-template-columns:1fr;gap:10px;margin-top:10px}'
      + '.mg-fg__box{border:1px solid rgba(0,0,0,.1);border-radius:10px;overflow:hidden;background:#faf7f3;display:flex;flex-direction:column}'
      + '.mg-fg__box img{width:100%;aspect-ratio:3/2;max-height:190px;object-fit:cover;display:block}'
      + '.mg-fg__ph{aspect-ratio:3/2;max-height:190px;display:flex;align-items:center;justify-content:center;font-size:26px;opacity:.35}'
      + '.mg-fg__cap{padding:8px 10px;font-size:12.5px;font-weight:600;line-height:1.3;color:#4a4a4a}';
    var st = document.createElement('style');
    st.id = 'mg-fg-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }

  // Klare Rückmeldung nach der Foto-Auswahl: Upload-Zustand, Qualitätsprüfung und
  // die Zusicherung, dass der Kunde sein Bild nicht selbst bearbeiten muss.
  function injectPhotoUploadStyles() {
    if (document.getElementById('mg-photo-upload-styles')) return;
    var css = ''
      + '.mg-photo-upload{display:grid;gap:10px;min-width:0}'
      + '.mg-photo-upload__card{display:none;gap:12px;border:1px solid #d7e6dc;border-radius:13px;padding:13px;background:linear-gradient(135deg,#f7fcf9 0%,#fbfdfb 100%);color:#29362e}'
      + '.mg-photo-upload__card.is-visible{display:grid}'
      + '.mg-photo-upload__card.is-uploading{border-color:#eadbb8;background:#fffaf0}'
      + '.mg-photo-upload__card.is-failed{border-color:#efc9c6;background:#fff7f6}'
      + '.mg-photo-upload__status{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:800;color:#247445}'
      + '.mg-photo-upload__card.is-uploading .mg-photo-upload__status{color:#846316}'
      + '.mg-photo-upload__card.is-failed .mg-photo-upload__status{color:#b23b3b}'
      + '.mg-photo-upload__status-icon{display:grid;place-items:center;flex:none;width:20px;height:20px;border-radius:50%;background:#23854a;color:#fff;font-size:13px;line-height:1}'
      + '.mg-photo-upload__card.is-uploading .mg-photo-upload__status-icon{background:#b88a20}'
      + '.mg-photo-upload__card.is-failed .mg-photo-upload__status-icon{background:#c64a42}'
      + '.mg-photo-upload__body{display:grid;grid-template-columns:68px minmax(0,1fr);align-items:start;gap:12px;min-width:0}'
      + '.mg-photo-upload__body.is-no-preview{grid-template-columns:1fr}'
      + '.mg-photo-upload__preview{display:none;width:68px;height:82px;padding:0;border:0;border-radius:9px;background:#ece8e3;overflow:hidden;cursor:zoom-in;box-shadow:0 0 0 1px rgba(48,70,56,.12)}'
      + '.mg-photo-upload__preview img{display:block;width:100%;height:100%;object-fit:cover}'
      + '.mg-photo-upload__copy{min-width:0;font-size:12.5px;line-height:1.45;color:#455148}'
      + '.mg-photo-upload__copy strong{display:block;margin:0 0 4px;font-size:14px;line-height:1.3;color:#26362c}'
      + '.mg-photo-upload__copy p{margin:0}'
      + '.mg-photo-upload__note{display:flex;align-items:flex-start;gap:7px;margin-top:8px;font-weight:700;color:#35463a}'
      + '.mg-photo-upload__note span:first-child{flex:none;color:#247445}'
      + '.mg-photo-upload__button{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;box-sizing:border-box;border:1.5px dashed #cbb9a7;background:#faf6f1;border-radius:11px;padding:11px 14px;cursor:pointer;font-size:13px;font-weight:700;color:#6f6155;text-align:center}'
      + '.mg-photo-upload__card.is-visible + .mg-photo-upload__button{border-style:solid;border-color:#d9d5d1;background:#fff;color:#4e4945}'
      + '.mg-photo-upload__button:focus-within{outline:2px solid #247445;outline-offset:2px}'
      + '.mg-photo-upload__assurance{margin:0;color:#455148;font-size:12.5px;line-height:1.45}'
      + '.mg-photo-upload__remove{justify-self:start;border:0;background:transparent;color:#9e1f31;padding:2px 0;font-size:12px;font-weight:750;text-decoration:underline;cursor:pointer}'
      + '@media(max-width:390px){.mg-photo-upload__body{grid-template-columns:58px minmax(0,1fr);gap:10px}.mg-photo-upload__preview{width:58px;height:72px}.mg-photo-upload__card{padding:12px}}';
    var st = document.createElement('style');
    st.id = 'mg-photo-upload-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function Personalizer(opts) {
    this.container = opts.container;
    this.handle = opts.handle;
    this.setProperties = opts.setProperties;
    this.setCartEnabled = opts.setCartEnabled;
    this.onReady = opts.onReady;
    this.selection = {};   // Options-Gruppen
    this.addonState = {};
    this.uploadCache = {}; // SHA-256 => bereits hochgeladenes Foto (nur diese Editor-Sitzung)
    this.values = {};      // Text je Zone
    this.touched = {};     // Feld wurde vom Kunden bearbeitet (Platzhalter dann nicht mehr zeigen)
    this.hasTextInput = false; // Nach der ersten Texteingabe keine Mustertexte mehr anzeigen
    this.photos = {};      // Foto (dataURL) je Zone
    this.motifChoice = {}; // gewähltes Symbol (URL) je Symbol-Auswahl-Zone
    this.cfonts = {};      // gewählte Schrift je Textzone (folgt der einen Auswahl)
    this.font = null;      // EINE Schriftart fürs ganze Produkt
    this.fontSelected = false; // true erst nach bewusster Auswahl durch den Kunden
    this.specialWish = ''; // optionaler Freitext-Wunsch
    this.inputs = {};      // DOM-Textfelder je Zone (fürs Markieren fehlender Pflichtfelder)
    this.pills = {};       // DOM-Foto-Knöpfe je Zone (dito)
    this.valid = false;    // sind alle Pflichtfelder ausgefüllt?
    this.showErrors = false; // Fehler erst zeigen, wenn der Kunde „In den Warenkorb" klickt
    this.sideOn = {};      // optionale Seiten, die der Kunde dazugewählt hat
    this.sideAspects = {};
    this.activeSide = 0;
    this.profiles = [];
    this.currentProfileKey = null;
    this.wrapW = 460;
    this.load();
  }

  Personalizer.prototype.load = function () {
    var self = this;
    var locale = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    fetch(APP_URL + '/api/storefront/products/' + encodeURIComponent(this.handle) + '/config?locale=' + encodeURIComponent(locale))
      .then(function (r) { return r.json(); })
      .then(function (cfg) {
        mgCanonicalConfig(cfg);
        // Produkt nicht personalisierbar -> der native Demo-Knopf des Themes
        // uebernimmt (sofort zeigen, nicht auf den Sicherheits-Timer warten).
        if (!cfg || !cfg.personalisierbar) {
          document.dispatchEvent(new CustomEvent('mg:personalizer:state', { detail: {
            ready: true,
            personalizable: false,
            hasPhoto: false,
            hasText: false,
            hasOptions: false,
            complete: true
          } }));
          if (window.MG && MG.showDemoFallback) MG.showDemoFallback();

          return;
        }
        self.cfg = cfg;
        self.profiles = (cfg.profiles || []).slice();
        if (self.profiles.length > 1) {
          self.currentProfileKey = self.profiles[0].key;
          self.applyProfileLayout(self.profiles[0]);
          self.updateShopSteps();
        }
        (cfg.groups || []).forEach(function (g) { self.selection[g.key] = []; });
        self.prepareProfile();
        self.restoreCartEdit();
        self.render();
        self.checkAddonAvailability();
        if (self.onReady) self.onReady();
        self.hookCartForm();
        self.hookColorChange();
        // Sofort sperren, falls Pflichtfelder offen sind – ohne auf die (verzögerte)
        // Preis-Antwort zu warten, damit der Knopf nicht kurz klickbar aufblitzt.
        self.missing = self.missingRequired();
        self.missingCount = self.missing.length;
        self.missingGroups = self.missingRequiredGroups();
        self.valid = self.missingCount === 0 && self.missingGroups.length === 0;
        self.updateNeeds();
        self.setCartEnabled(self.valid);
        self.refresh();
      })
      .catch(function (e) {
        console.warn('[MeinGeschenk] Konfiguration nicht geladen:', e);
        document.dispatchEvent(new CustomEvent('mg:personalizer:state', { detail: {
          ready: false,
          personalizable: true,
          loadFailed: true,
          complete: false
        } }));
        // App-Endpoint nicht erreichbar -> Demo-Knopf des Themes zeigen.
        if (window.MG && MG.showDemoFallback) MG.showDemoFallback();
      });
  };

  Personalizer.prototype.key = function (si, zi) { return si + '-' + zi; };

  // Mehrere Textflächen können dieselbe Kundeneingabe verwenden. So kann z. B.
  // "Max" einmal vollständig und zusätzlich als "M" im Logo erscheinen.
  Personalizer.prototype.textGroupKey = function (si, zi, zone) {
    return si + '-text-' + (zone.inputKey || ('zone-' + zi));
  };
  Personalizer.prototype.textSource = function (si, zi, zone) {
    var self = this, side = this.colorLayoutSide(si) || { zones: [] };
    var group = this.textGroupKey(si, zi, zone);
    return (side.zones || []).find(function (candidate, candidateIndex) {
      return candidate.type === 'text' && self.textGroupKey(si, candidateIndex, candidate) === group;
    }) || zone;
  };
  // Eine gemeinsame Wahrheit fuer Anzeige, Validierung und mobilen Sticky-Button.
  // Fotos sind Pflicht, solange die Produktkonfiguration sie nicht ausdruecklich
  // optional macht; Text ist nur mit required:true verpflichtend.
  Personalizer.prototype.isFieldRequired = function (si, zi, zone) {
    if (!zone) return false;
    // An accepted live design replaces the ordinary input on its mapped surface.
    // Unsaved drafts and other surfaces must not unlock required fields.
    if ((zone.type === 'text' || zone.type === 'photo') && this._mgLiveEditor?.coversField(si, zi)) return false;
    if (zone.type === 'photo') return zone.required !== false;
    if (zone.type === 'text') return !!this.textSource(si, zi, zone).required;
    return !!zone.required;
  };
  Personalizer.prototype.isTextInputOwner = function (si, zi, zone) {
    var self = this, side = this.colorLayoutSide(si) || { zones: [] };
    var group = this.textGroupKey(si, zi, zone);
    return (side.zones || []).findIndex(function (candidate, candidateIndex) {
      return candidate.type === 'text' && self.textGroupKey(si, candidateIndex, candidate) === group;
    }) === zi;
  };
  Personalizer.prototype.setLinkedTextValue = function (si, zi, zone, value) {
    var self = this, side = this.colorLayoutSide(si) || { zones: [] };
    var group = this.textGroupKey(si, zi, zone);
    var source = this.textSource(si, zi, zone);
    value = String(value || '').slice(0, source.maxChars || 20);
    (side.zones || []).forEach(function (candidate, candidateIndex) {
      if (candidate.type === 'text' && self.textGroupKey(si, candidateIndex, candidate) === group) {
        var key = self.key(si, candidateIndex);
        self.touched[key] = true;
        self.values[key] = value;
      }
    });
  };
  Personalizer.prototype.transformLinkedText = function (value, mode) {
    var text = String(value || '');
    if (mode === 'first') return (text.trim().charAt(0) || '').toUpperCase();
    if (mode === 'initials') {
      return text.trim().split(/\s+/).filter(Boolean).map(function (part) { return part.charAt(0); }).join('').toUpperCase();
    }
    return text;
  };

  Personalizer.prototype.applyProfileLayout = function (profile) {
    if (!profile || !this.cfg) return;
    this.cfg.sides = JSON.parse(JSON.stringify(profile.sides || []));
    this.cfg.colorMedia = JSON.parse(JSON.stringify(profile.colorMedia || {}));
    this.currentProfileKey = profile.key;
  };

  Personalizer.prototype.prepareProfile = function () {
    var self = this;
    this.cfonts = {};
    this.fontSelected = false;
    this.sideAspects = {};
    this._labelCount = null;

    // Standard-Schrift je Textzone + Seitenverhältnis je Seite messen.
    (this.cfg.sides || []).forEach(function (s, si) {
      (s.zones || []).forEach(function (z, zi) {
        if (z.type !== 'text') return;
        var erlaubt = (z.allowedFonts && z.allowedFonts.length) ? z.allowedFonts : null;
        var wunsch = z.font || 'elegant';
        self.cfonts[si + '-' + zi] = (!erlaubt || erlaubt.indexOf(wunsch) > -1) ? wunsch : erlaubt[0];
      });
      if (s.image) {
        var im = new Image();
        im.onload = function () {
          if (im.naturalHeight) {
            self.sideAspects[si] = im.naturalWidth / im.naturalHeight;
            self.renderStage();
          }
        };
        im.src = s.image;
      } else self.sideAspects[si] = 1;
    });

    // Die im Profil gesetzten Schriften bleiben die Vorgabe. Die gemeinsame
    // Schriftauswahl startet mit der am häufigsten verwendeten Schrift.
    var zaehler = {}, beste = null;
    Object.keys(this.cfonts).forEach(function (k) {
      var f = self.cfonts[k];
      zaehler[f] = (zaehler[f] || 0) + 1;
      if (!beste || zaehler[f] > zaehler[beste]) beste = f;
    });
    var choices = this.fontChoices();
    this.font = (beste && choices.indexOf(beste) > -1) ? beste : (choices[0] || beste || 'elegant');
  };

  Personalizer.prototype.updateShopSteps = function () {
    if (this.profiles.length < 2) return;
    var steps = document.querySelector('.mgp-steps');
    if (!steps) return;
    var rows = [
      [mgT("Look wählen"), mgT("Standard oder Profil")],
      [mgT("Ausführung wählen"), mgT("z. B. Farbe oder Variante")],
      ['Personalisieren', mgT("Text, Foto oder Symbol")],
      [mgT("Prüfen & bestellen"), mgT("Vorschau kontrollieren")]
    ];
    steps.innerHTML = '';
    steps.style.gridTemplateColumns = 'repeat(4,minmax(0,1fr))';
    rows.forEach(function (row, index) {
      steps.appendChild(node('li', {}, [
        node('span', {}, [String(index + 1)]),
        node('b', {}, [row[0]]),
        node('small', {}, [row[1]])
      ]));
    });
  };

  Personalizer.prototype.activateProfile = function (profileKey, shouldRender) {
    var profile = (this.profiles || []).find(function (p) { return p.key === profileKey; });
    if (!profile || profile.key === this.currentProfileKey) return false;

    if (this._mgLiveEditor) { this._mgLiveEditor.result = null; this._mgLiveEditor.restored = true; }

    this.applyProfileLayout(profile);
    this.activeSide = 0;
    this.values = {};
    this.touched = {};
    this.hasTextInput = false;
    this.photos = {};
    this.motifChoice = {};
    this.sideOn = {};
    this.inputs = {};
    this.pills = {};
    this.showErrors = false;
    this.prepareProfile();

    if (shouldRender !== false) {
      this.render();
      this.missing = this.missingRequired();
      this.missingCount = this.missing.length;
      this.missingGroups = this.missingRequiredGroups();
      this.valid = this.missingCount === 0 && this.missingGroups.length === 0;
      this.updateNeeds();
      this.setCartEnabled(this.valid);
      this.refresh();
    }

    return true;
  };

  // Öffnet der Kunde aus dem Warenkorb den Editor, werden seine bisherigen Angaben
  // übernommen. Die alte Warenkorb-Zeile bleibt dabei bestehen und wird erst nach
  // dem erneuten Speichern durch die neue Version ersetzt.
  Personalizer.prototype.restoreCartEdit = function () {
    var raw;
    try { raw = sessionStorage.getItem('mg_cart_edit'); } catch (e) { return; }
    if (!raw) return;

    var edit;
    try { edit = JSON.parse(raw); } catch (e) { return; }
    var isEditUrl = /[?&]mg_edit=1(?:&|$)/.test(window.location.search);
    if (!edit || !isEditUrl || !edit.lineKey) return;

    var self = this, props = edit.properties || {};
    if (Array.isArray(props)) {
      props = props.reduce(function (all, pair) {
        if (pair && pair.length > 1) all[pair[0]] = pair[1];
        return all;
      }, {});
    }
    var savedProfile = props['_mg_profile_key'];
    if (!savedProfile && props['Produkt-Look']) {
      var namedProfile = (this.profiles || []).find(function (p) { return p.name === props['Produkt-Look']; });
      savedProfile = namedProfile && namedProfile.key;
    }
    if (savedProfile) this.activateProfile(savedProfile, false);
    this.editLineKey = edit.lineKey;
    this.editQuantity = Number(edit.quantity || 1);
    this.editLine = Number(edit.line || 0);
    this.editVariantId = Number(edit.variantId || 0);
    this.editOriginalProperties = props;
    var editButton = document.getElementById('mgp-cart');
    if (editButton && !editButton.disabled) editButton.textContent = mgT("Änderungen speichern");

    (this.cfg.sides || []).forEach(function (side, si) {
      if (side.optional && Object.keys(props).some(function (name) { return name.indexOf((side.label || '') + ' · ') === 0; })) {
        self.sideOn[si] = true;
      }
      (side.zones || []).forEach(function (zone, zi) {
        var key = self.key(si, zi), name = self.propName(side, zone, zone.type === 'photo' ? mgT("Foto") : mgT("Gravur"));
        var value = props[name];
        if (zone.type === 'photo') {
          // Neue Warenkörbe zeigen im Checkout nur noch „Erfolgreich hochgeladen“.
          // Die echte URL liegt unsichtbar unter einem technischen Merkmal. Alte
          // Warenkörbe mit sichtbarer URL bleiben weiterhin bearbeitbar.
          var photoUrl = props[self.photoUrlPropName(si, zi)] || (/^https?:\/\//i.test(value || '') ? value : '');
          if (photoUrl) self.photos[key] = { url: photoUrl, orderUrl: photoUrl, ok: true, uploading: false };
          return;
        }
        if (!value) return;
        if (zone.type === 'text') self.setLinkedTextValue(si, zi, zone, value);
        if (zone.type === 'motif') {
          var choice = (zone.choices || []).find(function (c) { return c.name === value; });
          if (choice) self.motifChoice[key] = choice.url;
        }
      });
    });
    (this.cfg.groups || []).forEach(function (group) {
      var chosen = String(props[group.label] || '').split(', ');
      self.selection[group.key] = (group.choices || []).filter(function (choice) { return chosen.indexOf(choice.label) > -1; }).map(function (choice) { return choice.key; });
    });
    this.hasTextInput = Object.keys(this.values).length > 0;
    if (props['Besondere Wünsche']) this.specialWish = props['Besondere Wünsche'];
    Object.keys(FONT_LABELS).some(function (key) {
      if (FONT_LABELS[key] === props.Schrift) {
        self.font = key;
        self.fontSelected = true;
        return true;
      }
      return false;
    });
  };
  Personalizer.prototype.hasSides = function () {
    return (this.cfg.sides || []).some(function (s) { return (s.zones || []).length; });
  };

  Personalizer.prototype.renderProfilePicker = function () {
    var self = this;
    var wrap = node('div', { style: 'display:grid;gap:8px;min-width:0;max-width:100%' });
    wrap.appendChild(node('div', { style: 'display:flex;align-items:center;justify-content:space-between;gap:10px;min-width:0' }, [
      node('strong', { style: 'font-size:14px;min-width:0' }, [mgT("1. Produkt-Look wählen")]),
      node('span', { style: 'flex:none;font-size:11px;color:#777;background:#f3f3f3;border-radius:999px;padding:3px 8px' }, [mgT("optional")])
    ]));
    var row = node('div', { style: 'display:grid;grid-template-columns:repeat(auto-fit,minmax(min(118px,100%),1fr));gap:8px;min-width:0;max-width:100%' });

    (this.profiles || []).forEach(function (profile, profileIndex) {
      var active = profile.key === self.currentProfileKey;
      var button = node('button', {
        type: 'button',
        'aria-pressed': active ? 'true' : 'false',
        style: 'display:grid;grid-template-columns:42px minmax(0,1fr);align-items:center;gap:8px;padding:7px;text-align:left;cursor:pointer;border-radius:11px;border:'
          + (active ? '2px solid #c72f46' : '1px solid #ccc') + ';background:' + (active ? '#fff1f3' : '#fff'),
        onclick: function () { self.activateProfile(profile.key, true); }
      });
      if (profile.previewImage) {
        button.appendChild(node('img', {
          src: profile.previewImage,
          alt: '',
          style: 'width:42px;height:42px;object-fit:cover;border-radius:8px;display:block;background:#eee'
        }));
      } else {
        button.appendChild(node('span', { style: 'width:42px;height:42px;border-radius:8px;background:#eee;display:grid;place-items:center;color:#888' }, ['◇']));
      }
      button.appendChild(node('span', { style: 'min-width:0;overflow:hidden;text-overflow:ellipsis;font-size:13px;font-weight:700' }, [(profileIndex + 1) + ' · ' + mgLabel(profile.name,profile,'name')]));
      row.appendChild(button);
    });
    wrap.appendChild(row);

    return wrap;
  };

  Personalizer.prototype.renderOptionalDetails = function () {
    var details = node('details', {
      style: 'border:1px solid #ded8d2;border-radius:11px;background:#fff;overflow:hidden'
    });
    var summary = node('summary', {
      style: 'cursor:pointer;padding:11px 13px;font-size:13px;font-weight:800;color:#4f4741;list-style-position:inside'
    }, [mgT("Weitere Angaben (optional)")]);
    var body = node('div', {
      style: 'display:grid;gap:12px;padding:2px 13px 13px'
    });
    (this.optionalDetailFields || []).forEach(function (field) { body.appendChild(field); });
    details.appendChild(summary);
    details.appendChild(body);
    if (this.optionalDetailsOpen) details.open = true;

    return details;
  };

  // ---- Aufbau der Oberfläche --------------------------------------------------
  Personalizer.prototype.render = function () {
    var self = this;
    this.container.innerHTML = '';
    this.optionalDetailFields = [];
    this.optionalDetailsOpen = false;
    var box = node('div', { style: 'font-family:inherit;display:grid;gap:14px;width:100%;max-width:100%;min-width:0;box-sizing:border-box' });

    // Optionaler Zusatz; ohne gültige Admin-Freigabe bleibt dieser Slot leer.
    if (window.MGLiveEditor) window.MGLiveEditor.mount(this, box, APP_URL);

    if (this.profiles.length > 1) box.appendChild(this.renderProfilePicker());

    // Native Varianten-Auswahl (Farbe/Grösse) EINMAL aus dem Theme herausloesen und
    // fortan oben in den Editor haengen – so wirkt alles wie eine Einheit statt zwei
    // getrennter Bereiche. Die Klick-Logik des Themes bleibt an den Knoepfen haengen.
    if (this._variantPicks === undefined) {
      var vp = document.getElementById('mgp-variantpicks');
      this._variantPicks = (vp && vp.querySelector('.mgp-swatch, .mgp-variant')) ? vp : null;
      if (this._variantPicks && this._variantPicks.parentNode) {
        this._variantPicks.parentNode.removeChild(this._variantPicks);
        this._variantPicks.style.marginBottom = '4px';
        this._variantPicks.querySelectorAll('.mgp-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () { setTimeout(function () { self.renderStage(); }, 0); });
        });
      }
    }
    if (this._variantPicks) {
      if (this.profiles.length > 1) box.appendChild(node('strong', { style: 'font-size:14px' }, [mgT("2. Ausführung wählen")]));
      box.appendChild(this._variantPicks);
    }

    // 1) Editor (Felder + optionale Bildvorschau), falls Seiten mit Zonen vorhanden.
    this.stageHost = null;
    if (this.hasSides()) {
      if (this.profiles.length > 1) box.appendChild(node('strong', { style: 'font-size:14px' }, [mgT("3. Personalisieren")]));
      if ((this.cfg.sides || []).length > 1) box.appendChild(this.renderSideTabs());
      // Bild-Vorschau nur, wenn im Panel eingeschaltet (Standard an). Ob auf DIESER
      // Seite auch live graviert wird, entscheidet renderStage – das Produktbild
      // selbst bleibt sichtbar.
      if (this.cfg.livePreview !== false) {
        // Inline: bevorzugt in die grosse Galerie links zeichnen (sonst saehe der
        // Kunde dasselbe Produkt zweimal). Im Popup gehoert die Vorschau INS Popup –
        // die Galerie laege sonst hinter dem Overlay und waere unsichtbar.
        this.stageHost = (this.mode() !== 'popup' && this.mountGalleryStage()) || (function () {
          var h = node('div', { style: 'display:flex;justify-content:center' });
          box.appendChild(h);

          return h;
        })();
      }
      // Optionale Seite (z.B. Rückseite als Zusatzleistung): erst ein Schalter,
      // die Felder erscheinen und gelten erst, wenn der Kunde ihn einschaltet.
      var aktiv = (this.cfg.sides || [])[this.activeSide] || {};
      if (aktiv.optional) box.appendChild(this.renderSideToggle(aktiv, this.activeSide));

      if (this.sideActive(this.activeSide)) box.appendChild(this.renderZoneControls());
    }

    // 2) Options-Gruppen (Farben etc.) + Zusatzoptionen.
    (this.cfg.groups || []).forEach(function (g) { box.appendChild(self.renderGroup(g)); });
    (this.cfg.addons || []).forEach(function (a, i) {
      var cb = node('input', { type: 'checkbox', onchange: function (e) { self.addonState[i] = e.target.checked; self.refresh(); } });
      // Zusatzoptionen gelten fuer das ganze Produkt, nicht pro Vorder-/Rueckseite.
      // render() wird beim Seitenwechsel neu aufgebaut; ohne diese Ruecksetzung sah
      // dieselbe Geschenkbox auf der anderen Seite faelschlich wieder ungewaehlt aus.
      var blocked = a.available === false || (a.productHandle && a.available === undefined);
      if (a.available === false) self.addonState[i] = false;
      cb.checked = !!self.addonState[i];
      cb.disabled = !!blocked;
      var status = a.available === false ? (a.stockUnknown ? mgT(" – Zurzeit nicht verfügbar") : mgT(" – Zurzeit ausverkauft")) : (blocked ? mgT(" – Verfügbarkeit wird geprüft …") : ' (+ ' + money(self.cfg.currency, a.price) + ')');
      var label = node('label', { style: 'display:flex;gap:8px;align-items:center;font-size:14px;flex-wrap:wrap', 'data-mgp-addon': String(i) }, [cb, mgLabel(a.label,a) + status]);
      box.appendChild(label);
      a._stockLabel = label;
    });

    // Optionales Freitextfeld „Besondere Wünsche" (pro Produkt im Panel geschaltet).
    if (this.cfg.specialWishes) {
      var wishWrap = node('div', { style: 'display:grid;gap:5px;min-width:0' });
      wishWrap.appendChild(node('label', { style: 'font-weight:700;font-size:13px;display:flex;align-items:center;flex-wrap:wrap;min-width:0;overflow-wrap:anywhere' },
        [mgLabel(this.cfg.specialWishesLabel) || mgT("Besondere Wünsche"),
         node('span', { style: 'margin-left:7px;font-size:11px;font-weight:600;color:#999' }, [mgT("optional")])]));
      var wishInput = node('textarea', {
        style: 'width:100%;border:1px solid #ccc;border-radius:9px;padding:9px 11px;font-size:14px;min-height:64px;resize:vertical',
        placeholder: mgT("z.B. Schrift etwas grösser, Lieferung bis Freitag …"),
        maxlength: 300,
        oninput: function (e) { self.specialWish = e.target.value; self.writeProps(); }
      });
      if (this.specialWish) wishInput.value = this.specialWish;
      wishWrap.appendChild(wishInput);
      this.optionalDetailFields.push(wishWrap);
      if (this.specialWish) this.optionalDetailsOpen = true;
    }

    if (this.optionalDetailFields.length) box.appendChild(this.renderOptionalDetails());

    // Ruhiger Dauer-Hinweis, WAS noch fehlt, damit der graue Warenkorb-Knopf nie
    // grundlos gesperrt wirkt. Erst der rote errorBox-Text kommt nach dem Klick.
    this.needsBox = node('div', { style: 'display:none;font-size:13px;color:#7a5b12;background:#fffaf0;border:1px solid #f0e3c2;border-radius:10px;padding:9px 12px' });
    this.errorBox = node('div', { style: 'display:none;color:#b23b3b;font-size:13px;font-weight:600;background:#fdf1f0;border:1px solid #f3cfcc;border-radius:10px;padding:9px 12px' });
    this.surchargeBox = node('div', { style: 'font-size:13px;color:#555' });
    this.materialBox = node('div', { style: 'display:none;font-size:12px;color:#8a6d1a;background:#fffaf0;padding:7px 10px;border-radius:8px' });
    box.appendChild(this.needsBox);
    box.appendChild(this.errorBox);
    box.appendChild(this.materialBox);

    // Ansicht: inline direkt im Slot, oder als Popup mit Öffnen-Knopf (kommt aus /config).
    if (this.mode() === 'popup') this.placePopup(box);
    else this.container.appendChild(box);

    this.measureWrap();
    this.renderStage();
  };

  Personalizer.prototype.mode = function () {
    // Feste Theme-Wahl (data-editor-mode-force) schlaegt die App-Einstellung –
    // so kann der Haendler im Theme "immer als roter Knopf" erzwingen.
    if (this.container.getAttribute('data-editor-mode-force') === '1') {
      return this.container.getAttribute('data-editor-mode') || 'inline';
    }

    return (this.cfg && this.cfg.editorMode) || this.container.getAttribute('data-editor-mode') || 'inline';
  };

  // Popup-Ansicht: ein Knopf im Slot öffnet ein Overlay-Fenster mit dem Editor. Das
  // Overlay wird einmal an <body> gehängt; bei jedem Neuaufbau tauschen wir nur den Inhalt.
  Personalizer.prototype.placePopup = function (box) {
    var self = this;
    if (!this._popup) {
      this._popupBody = node('div', { style: 'padding:16px 16px 20px;overflow:auto;max-height:82vh' });
      var head = node('div', { style: 'display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eee' }, [
        node('strong', { style: 'font-size:16px' }, ['Live-Editor']),
        node('button', { type: 'button', 'aria-label': mgT("Schliessen"), style: 'border:0;background:none;font-size:20px;cursor:pointer;line-height:1', onclick: function () { self.closePopup(); } }, ['✕'])
      ]);
      var card = node('div', { style: 'background:#fff;border-radius:18px;width:100%;max-width:560px;margin:24px auto;box-shadow:0 24px 60px rgba(0,0,0,.35);overflow:hidden' }, [head, this._popupBody]);
      this._popup = node('div', {
        style: 'position:fixed;inset:0;z-index:99999;display:none;background:rgba(20,15,14,.55);overflow:auto;padding:16px',
        onclick: function (e) { if (e.target === self._popup) self.closePopup(); }
      }, [card]);
      document.body.appendChild(this._popup);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closePopup(); });
    }
    this._popupBody.innerHTML = '';
    this._popupBody.appendChild(box);

    // Öffnen-Knopf (der Slot wurde beim Neuaufbau geleert -> hier neu setzen).
    if (!this._openBtn) {
      var label = this.container.getAttribute('data-open-label') || mgT("Live personalisieren →");
      this._openBtn = node('button', {
        type: 'button', class: 'mgp-personalize',
        style: 'width:100%;border:0;background:#c6283d;color:#fff;border-radius:14px;padding:15px;font-weight:800;font-size:16px;cursor:pointer;box-shadow:0 12px 28px rgba(198,40,61,.25)',
        onclick: function () { self.openPopup(); }
      }, ['🎨 ' + label]);
    }
    this.container.appendChild(this._openBtn);
  };

  Personalizer.prototype.openPopup = function () {
    if (!this._popup) return;
    this._popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
    this.measureWrap();
    this.renderStage();
  };
  Personalizer.prototype.closePopup = function () {
    if (!this._popup) return;
    this._popup.style.display = 'none';
    document.body.style.overflow = '';
  };

  /**
   * Die Live-Vorschau in die grosse Produktgalerie links hängen (falls das Theme
   * einen Slot dafür anbietet). Das Original-Produktbild und die Miniaturen werden
   * dabei ausgeblendet – sonst stünde dasselbe Produkt zweimal auf der Seite.
   *
   * @return {Element|null} der Host, in den renderStage zeichnet
   */
  Personalizer.prototype.mountGalleryStage = function () {
    var slot = (window.MG && MG.slots && MG.slots.preview) || null;
    if (!slot) return null;

    if (this._galleryHost && slot.contains(this._galleryHost)) return this._galleryHost;

    // Ursprüngliches Produktbild merken – Seiten ohne eigenes Bild schalten darauf
    // zurück, statt das Bild der vorherigen Seite stehen zu lassen.
    var main = document.getElementById('mgp-main');
    if (main) {
      this._nativeSrc = main.getAttribute('src');
      this._nativeSrcset = main.getAttribute('srcset');
    }

    // Nur eine transparente Ebene ÜBER dem Theme-Bild. Bild und Miniaturen des
    // Themes bleiben unangetastet und voll funktionsfähig.
    var host = node('div', {
      style: 'position:absolute;inset:0;pointer-events:none;z-index:2'
    });
    slot.appendChild(host);
    this._galleryHost = host;

    // Klickt der Kunde eine Miniatur, zeigt die Galerie ein anderes Foto – die
    // Gravur passt dann nicht mehr dazu und wird ausgeblendet, bis er weiter
    // personalisiert (dann setzt renderStage das Seitenbild wieder).
    document.querySelectorAll('.mgp-thumb').forEach(function (b) {
      b.addEventListener('click', function () { host.innerHTML = ''; });
    });

    return host;
  };

  Personalizer.prototype.measureWrap = function () {
    if (this._galleryHost && this._galleryHost.clientWidth) {
      this.wrapW = this._galleryHost.clientWidth;

      return;
    }

    var w = (this.stageHost && this.stageHost.clientWidth) || this.container.clientWidth || 460;
    this.wrapW = Math.max(240, Math.min(w, 520));
  };

  /**
   * Wo liegt das Bild innerhalb der Bühne? Es wird formatfüllend eingepasst
   * (object-fit: cover), ragt also über den Rand hinaus, wenn die Seitenverhältnisse
   * nicht passen. Die Gravur-Zonen sind relativ zum GANZEN Bild gespeichert – ohne
   * diese Umrechnung sässen sie im beschnittenen Kasten an der falschen Stelle.
   *
   * @return {{x:number,y:number,w:number,h:number}} Bildrechteck in Bühnen-Pixeln
   */
  Personalizer.prototype.imageRect = function (a, boxW, boxH) {
    var boxA = boxW / boxH;
    var w, h;

    if (a > boxA) {           // Bild breiter als der Kasten -> links/rechts beschnitten
      h = boxH; w = boxH * a;
    } else {                  // Bild höher -> oben/unten beschnitten
      w = boxW; h = boxW / a;
    }

    return { x: (boxW - w) / 2, y: (boxH - h) / 2, w: w, h: h };
  };

  Personalizer.prototype.renderSideTabs = function () {
    var self = this;
    var row = node('div', { style: 'display:flex;gap:7px;flex-wrap:wrap' });
    (this.cfg.sides || []).forEach(function (s, si) {
      var on = si === self.activeSide;
      row.appendChild(node('button', {
        type: 'button',
        style: 'border:1px solid ' + (on ? '#c72f46' : '#ccc') + ';background:' + (on ? '#fff1f3' : '#fff') + ';color:' + (on ? '#c72f46' : '#333') + ';border-radius:9px;padding:6px 11px;cursor:pointer;font-size:13px',
        onclick: function () { self.activeSide = si; self.render(); }
      }, [mgLabel(s.label,s) || (mgT("Seite ") + (si + 1))]));
    });
    return row;
  };

  Personalizer.prototype.stageDims = function (si) {
    // In der Galerie füllt die Bühne den ganzen Kasten (das Bild wird formatfüllend
    // eingepasst). Im Panel bekommt sie das Seitenverhältnis des Bildes.
    if (this._galleryHost && this._galleryHost.clientWidth) {
      return { w: this._galleryHost.clientWidth, h: this._galleryHost.clientHeight };
    }

    var w = this.wrapW || 460, a = this.sideAspects[si] || 1;

    return { w: w, h: Math.round(w / a) };
  };
  Personalizer.prototype.baseSize = function (zone) {
    return (zone.type === 'photo' || zone.type === 'graphic' || zone.type === 'motif' || zone.type === 'symbol')
      ? [600, 600]
      : [1000, 460];
  };

  // Eine Farbwahl darf ein eigenes Foto und eigene Gravurpunkte besitzen. Fehlt
  // fuer die gewaehlte Farbe eine Kopie, bleibt das Standard-Layout aktiv.
  Personalizer.prototype.colorLayoutSide = function (si) {
    var base = (this.cfg.sides || [])[si];
    if (!base) return base;
    var colorGroup = (this.cfg.groups || []).find(function (g) { return g.asVariant; });
    var colorKey = colorGroup && (this.selection[colorGroup.key] || [])[0];
    // Ohne App-Farbgruppe kommt die Farbe direkt aus der echten Shopify-Auswahl.
    if (!colorKey) {
      var active = document.querySelector('.mgp-swatches .mgp-swatch.active');
      var label = active && active.getAttribute('data-value');
      var editorColor = (this.cfg.editorColors || []).find(function (c) { return c.label === label; });
      colorKey = editorColor && editorColor.key;
    }
    var media = colorKey && this.cfg.colorMedia && this.cfg.colorMedia[colorKey];
    return (media && media.sides && media.sides[base.key]) || base;
  };

  /** Aktuell gewähltes Symbol-Motiv; nur bei Pflichtfeldern gilt das erste als Standard. */
  Personalizer.prototype.motifUrl = function (z, si, zi) {
    var chosen = this.motifChoice[this.key(si, zi)];
    if (chosen) return chosen;
    if (!z.required) return null;
    var c = (z.choices || [])[0];
    return c ? c.url : null;
  };

  // Zeichnet die aktive Seite: Produktbild + je Zone ein gewarpter Overlay.
  Personalizer.prototype.renderStage = function () {
    if (!this.stageHost) return;
    var self = this, si = this.activeSide, side = this.colorLayoutSide(si);
    if (!side) return;

    // Die Vorschau kann pro Seite abgeschaltet werden – auch für die Vorderseite.
    // Das normale Theme-Produktbild bleibt dabei sichtbar, nur die Gravur-Ebene weg.
    if (side.livePreview === false) {
      this.stageHost.innerHTML = '';
      return;
    }

    // Native Galerie vorhanden? Dann nur überlagern, nichts nachbauen.
    if (this._galleryHost) {
      this.renderGalleryOverlay(side, si);

      return;
    }

    this.measureWrap();
    var d = this.stageDims(si);

    var stage = node('div', { style: 'position:relative;width:' + d.w + 'px;height:' + d.h + 'px;max-width:100%;border-radius:12px;overflow:hidden;background:#f4f2ee' });
    if (side.image) stage.appendChild(node('img', { src: side.image, style: 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block' }));

    if (!this.sideActive(si)) {          // abgewaehlte Zusatzseite: nur das Bild
      this.stageHost.innerHTML = '';
      this.stageHost.appendChild(stage);

      return;
    }

    // Bildrechteck innerhalb der Bühne – die Zonen hängen am Bild, nicht am Kasten.
    var a = this.sideAspects[si] || 1;
    var r = this.imageRect(a, d.w, d.h);

    (side.zones || []).forEach(function (z, zi) {
      var surf = self.zoneNode(z, zi, si, r);
      if (surf) stage.appendChild(surf);
    });

    this.stageHost.innerHTML = '';
    this.stageHost.appendChild(stage);
  };

  /**
   * Eine einzelne Zone als gewarpte Fläche. Von beiden Darstellungen genutzt:
   * der eigenen Bühne im Panel und dem Overlay über der nativen Galerie.
   *
   * @param {object} r Bildrechteck (Position/Grösse des Bildes in Pixeln)
   */
  Personalizer.prototype.zoneNode = function (z, zi, si, r) {
    if (!z.points || z.points.length < 4) return null;
    var previewMode = z.previewMode || (z.type === 'photo'
      ? (z.livePreview === true ? 'live' : 'marker')
      : (z.livePreview === false ? 'hidden' : 'live'));
    if (previewMode === 'hidden') return null;
    // Foto-Zonen sind standardmässig nur Upload-Felder. Dadurch erscheint keine
    // künstliche leere Kreisfläche auf dem Produkt; bei Bedarf kann der Händler
    // die Live-Vorschau für genau dieses Feld aktivieren.

    var bs = this.baseSize(z), bw = bs[0], bh = bs[1];
    var dst = z.points.map(function (p) { return [r.x + p[0] * r.w, r.y + p[1] * r.h]; });
    // Textbreite hängt von Inhalt und Laufweite ab. Die vier Punkte bestimmen seine
    // Position/Perspektive, dürfen aber nicht die letzte Ziffer abschneiden. Fotos und
    // Motive bleiben dagegen innerhalb ihrer Fläche beschnitten.
    var overflow = z.type === 'text' || z.type === 'symbol' ? 'visible' : 'hidden';
    var surf = node('div', { style: 'position:absolute;top:0;left:0;width:' + bw + 'px;height:' + bh + 'px;transform-origin:0 0;transform:' + matrix3dFor(bw, bh, dst) + ';display:flex;align-items:center;justify-content:center;pointer-events:none;overflow:' + overflow });

    if (z.type === 'photo' && previewMode === 'marker') {
      var markerRadius = z.shape === 'circle' ? '50%' : '10px';
      var distance = function (a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1]); };
      var markerWidth = (distance(dst[0], dst[1]) + distance(dst[2], dst[3])) / 2;
      var markerHeight = (distance(dst[0], dst[3]) + distance(dst[1], dst[2])) / 2;
      var markerScale = '';
      if (z.shape === 'circle' && markerWidth && markerHeight) {
        markerScale = markerWidth < markerHeight
          ? 'transform:scaleY(' + (markerWidth / markerHeight) + ');'
          : 'transform:scaleX(' + (markerHeight / markerWidth) + ');';
      }
      surf.appendChild(node('div', { style: 'width:100%;height:100%;box-sizing:border-box;border-radius:' + markerRadius
        + ';border:2px dashed rgba(120,85,55,.82);background:repeating-linear-gradient(-45deg,rgba(130,95,65,.30) 0 8px,rgba(255,255,255,.16) 8px 16px);'
        + 'display:flex;align-items:center;justify-content:center;text-align:center;color:' + (z.markerColor || '#60432f') + ';font-family:Arial,sans-serif;font-size:48px;font-weight:800;line-height:1.08;text-shadow:0 1px 0 rgba(255,255,255,.72);' + markerScale }, [mgLabel(z.markerLabel,z,'markerLabel') || mgT("Dein Foto")]));
    } else if (z.type === 'photo') {
      var p = this.photos[this.key(si, zi)];
      var radius = z.shape === 'circle' ? '50%' : '10px';
      surf.appendChild(node('div', { style: 'width:100%;height:100%;border-radius:' + radius + ';overflow:hidden;' + (p ? "background:center/cover no-repeat url('" + p.url + "')" : 'background:linear-gradient(135deg,#c8b8a6,#eaddce)') }));
    } else if (z.type === 'graphic' && z.image) {
      // Farbige CSS-Maske mit normalem SVG-Bild als Safari-/CORS-Fallback.
      surf.appendChild(graphicPreviewNode(z.image, z.color));
    } else if (z.type === 'motif') {
      // Kunde wählt eines der erlaubten Symbole; optionale Felder bleiben zunächst leer.
      var murl = this.motifUrl(z, si, zi);
      if (murl) {
        surf.appendChild(graphicPreviewNode(murl, z.color));
      }
    } else if (z.type === 'symbol') {
      // Panel legt das Glyph in z.symbol ab (z.sample war der alte, falsche Feldname).
      surf.appendChild(node('div', { style: 'font-size:' + (z.size || 160) + 'px;line-height:1;color:' + (z.color || '#5b5b5b') }, [z.symbol || z.sample || '★']));
    } else {
      surf.appendChild(node('div', { style: this.textStyle(z, si, zi) }, [this.displayText(z, si, zi)]));
    }

    return surf;
  };

  /**
   * Native Variante: die Galerie des Themes bleibt, wie sie ist – wir setzen nur
   * ihr Bild auf die aktive Seite und legen die Gravur darüber. Kein zweites Bild,
   * keine versteckten Miniaturen.
   */
  Personalizer.prototype.renderGalleryOverlay = function (side, si) {
    var self = this;
    var host = this._galleryHost;
    var main = document.getElementById('mgp-main');
    if (!host || !main) return;

    host.innerHTML = '';

    // Bild der aktiven Seite im nativen <img> zeigen (srcset muss weg, sonst
    // ueberschreibt der Browser unsere Quelle wieder). Hat die Seite kein eigenes
    // Bild, zurueck auf das urspruengliche Produktbild.
    var ziel = side.image || this._nativeSrc;
    if (ziel && main.getAttribute('src') !== ziel) {
      if (side.image) {
        main.removeAttribute('srcset');
      } else if (this._nativeSrcset) {
        main.setAttribute('srcset', this._nativeSrcset);
      }
      main.setAttribute('src', ziel);
    }

    // Bei einer abgewählten Zusatzseite nur das Produktbild zeigen.
    if (!this.sideActive(si)) return;

    var draw = function () {
      host.innerHTML = '';
      var boxW = host.clientWidth, boxH = host.clientHeight;
      if (!boxW || !boxH) return;

      // Seitenverhaeltnis vom tatsaechlich angezeigten Bild nehmen.
      var a = (main.naturalWidth && main.naturalHeight)
        ? main.naturalWidth / main.naturalHeight
        : (self.sideAspects[si] || 1);
      var r = self.imageRect(a, boxW, boxH);

      (side.zones || []).forEach(function (z, zi) {
        var surf = self.zoneNode(z, zi, si, r);
        if (surf) host.appendChild(surf);
      });
    };

    if (main.complete && main.naturalWidth) draw();
    else main.addEventListener('load', draw, { once: true });
  };

  Personalizer.prototype.displayText = function (zone, si, zi) {
    var key = this.key(si, zi), source = this.textSource(si, zi, zone), t = this.values[key];
    // Die Mustergravur zeigt den idealen Zustand vor der ersten Eingabe. Löscht
    // der Kunde ein bearbeitetes Feld, bleibt es in der Vorschau bewusst leer.
    if (t === undefined || (t === '' && !this.touched[key])) {
      t = this.hasTextInput ? '' : (mgLabel(source.sample,source,'sample') || mgLabel(source.label,source) || '');
    }
    if (source.maxChars && t.length > source.maxChars) t = t.slice(0, source.maxChars);
    return this.transformLinkedText(t, zone.displayMode || 'full');
  };
  Personalizer.prototype.textStyle = function (zone, si, zi) {
    var fam = FONTS[this.cfonts[this.key(si, zi)]] || FONTS[zone.font] || FONTS.elegant;
    return 'font-family:' + fam + ';font-size:' + (zone.size || 64) + 'px;letter-spacing:' + (zone.spacing || 0) + 'px;color:' + (zone.color || '#5b5b5b') +
      ';text-align:' + (zone.align || 'center') + ';font-weight:600;white-space:' + (zone.multiline ? 'pre-line' : 'nowrap') +
      ';text-transform:' + (zone.uppercase ? 'uppercase' : 'none') + ';text-shadow:0 1px 0 rgba(255,255,255,.45),0 -1px 1px rgba(0,0,0,.35)';
  };

  // Eingabefelder je Zone (Text tippen / Foto hochladen / Schrift wählen).
  Personalizer.prototype.renderZoneControls = function () {
    var self = this, si = this.activeSide, side = this.colorLayoutSide(si);
    var wrap = node('div', { style: 'display:grid;gap:11px;min-width:0;max-width:100%' });
    var seenTextGroups = {};
    var fontPickerPlaced = false;

    (side.zones || []).forEach(function (z, zi) {
      // Fest platzierte Grafiken und Symbol-Glyphen sind Teil des Looks und keine
      // Kundeneingabe. Sie gehoeren nur in die Live-Vorschau, nicht als leere Zeile
      // mit einem technischen Dateinamen in das Formular.
      if (z.type === 'graphic' || z.type === 'symbol') return;
      var k = self.key(si, zi);
      var source = z;
      if (z.type === 'text') {
        var group = self.textGroupKey(si, zi, z);
        if (seenTextGroups[group]) return;
        seenTextGroups[group] = true;
        source = self.textSource(si, zi, z);
      }
      var field = node('div', { style: 'display:grid;gap:5px;min-width:0;max-width:100%' });
      var istPflicht = self.isFieldRequired(si, zi, z);
      var lab = node('label', { style: 'font-weight:700;font-size:13px;display:flex;align-items:center;flex-wrap:wrap;min-width:0;max-width:100%;overflow-wrap:anywhere;word-break:break-word' }, [(mgLabel(source.label,source) || mgT("Feld"))]);
      if (istPflicht) lab.appendChild(reqBadge());
      else lab.appendChild(node('span', { style: 'margin-left:7px;font-size:11px;font-weight:600;color:#999' }, [mgT("optional")]));
      field.appendChild(lab);

      if (z.type === 'photo') {
        // Nach der Auswahl wird der einfache Knopf zur klaren Statuskarte: Erst wenn
        // das Original wirklich am Server angekommen ist, erscheint die grüne
        // Erfolgsmeldung. Gleichzeitig erklären wir unsere manuelle Bildkontrolle.
        injectPhotoUploadStyles();
        var fileInput = node('input', { type: 'file', accept: 'image/*', style: 'position:absolute;width:1px;height:1px;opacity:0;overflow:hidden' });
        var previewImage = node('img', { alt: mgT("Dein hochgeladenes Foto") });
        var previewButton = node('button', { type: 'button', title: mgT("Foto vergrössern"), 'aria-label': mgT("Hochgeladenes Foto vergrössern"), class: 'mg-photo-upload__preview' }, [previewImage]);
        var statusIcon = node('span', { class: 'mg-photo-upload__status-icon', 'aria-hidden': 'true' }, ['…']);
        var statusText = node('span', {}, [mgT("Foto wird sicher hochgeladen …")]);
        var card = node('div', { class: 'mg-photo-upload__card', role: 'status', 'aria-live': 'polite' });
        var cardBody = node('div', { class: 'mg-photo-upload__body is-no-preview' }, [
          previewButton,
          node('div', { class: 'mg-photo-upload__copy' }, [
            node('strong', {}, [mgT("Wir prüfen dein Foto persönlich.")]),
            node('p', {}, [mgT("Vor der Gravur kontrollieren wir Bildausschnitt und Qualität. Bei Bedarf schneiden wir es passend zu, stellen es frei und optimieren es für die Gravur.")]),
            node('div', { class: 'mg-photo-upload__note' }, [
              node('span', { 'aria-hidden': 'true' }, ['♡']),
              node('span', {}, [mgT("Du musst dein Bild nicht selbst bearbeiten.")])
            ])
          ])
        ]);
        card.appendChild(node('div', { class: 'mg-photo-upload__status' }, [statusIcon, statusText]));
        card.appendChild(cardBody);
        var buttonIcon = node('span', { 'aria-hidden': 'true' }, ['▧']);
        var buttonText = node('span', {}, [mgT("Foto auswählen")]);
        var showPreview = function (src) {
          if (!src) return;
          previewImage.src = src;
          previewButton.style.display = 'inline-flex';
          cardBody.classList.remove('is-no-preview');
          previewButton.onclick = function () { openPhotoPreview(src); };
        };
        var pill = node('label', {
          class: 'mg-photo-upload__button'
        }, [buttonIcon, buttonText, fileInput]);
        var removeButton = node('button', { type: 'button', class: 'mg-photo-upload__remove' }, [mgT("Foto entfernen")]);
        removeButton.addEventListener('click', function () {
          delete self.photos[k];
          fileInput.value = '';
          self.writeProps();
          updatePhotoControl();
          self.renderStage();
          self.refresh();
        });
        var updatePhotoControl = function () {
          var photo = self.photos[k];
          if (!photo) {
            card.className = 'mg-photo-upload__card';
            buttonIcon.textContent = '▧';
            buttonText.textContent = mgT("Foto auswählen");
            removeButton.hidden = true;
            return;
          }

          card.className = 'mg-photo-upload__card is-visible';
          removeButton.hidden = false;
          if (photo.url) showPreview(photo.url);

          if (photo.uploadFailed) {
            card.classList.add('is-failed');
            statusIcon.textContent = '!';
            statusText.textContent = mgT("Foto konnte nicht hochgeladen werden.");
            buttonText.textContent = mgT("Foto nochmals auswählen");
          } else if (photo.uploading || !photo.orderUrl) {
            card.classList.add('is-uploading');
            statusIcon.textContent = '…';
            statusText.textContent = mgT("Foto wird sicher hochgeladen …");
            buttonText.textContent = mgT("Anderes Foto auswählen");
          } else {
            card.classList.add('is-success');
            statusIcon.textContent = '✓';
            statusText.textContent = mgT("Foto erfolgreich hochgeladen!");
            buttonText.textContent = mgT("Anderes Foto hochladen");
          }
          buttonIcon.textContent = '▧';
        };
        fileInput.addEventListener('change', function (e) {
          self.onPhoto(si, zi, e);
          var photo = self.photos[k];
          if (photo) photo.updateControl = updatePhotoControl;
          updatePhotoControl();
        });
        self.pills[k] = pill;
        field.appendChild(node('div', { class: 'mg-photo-upload' }, [
          card,
          pill,
          node('p', { class: 'mg-photo-upload__assurance' }, [mgT("✓ Wir entfernen den Hintergrund und optimieren dein Foto für die Gravur. Ist die Qualität nicht ausreichend, melden wir uns vor der Herstellung.")]),
          removeButton
        ]));
        if (self.photos[k]) self.photos[k].updateControl = updatePhotoControl;
        updatePhotoControl();
        var guide = self.photoGuideNode();
        if (guide) field.appendChild(guide);
      } else if (z.type === 'text') {
        var input = node(source.multiline ? 'textarea' : 'input', {
          style: 'width:100%;max-width:100%;min-width:0;box-sizing:border-box;border:1px solid #ccc;border-radius:9px;padding:9px 11px;font-size:14px',
          placeholder: mgLabel(source.sample,source,'sample') || mgLabel(source.label,source) || mgT("Dein Text"),
          maxlength: source.maxChars || 20,
          oninput: function (e) { self.hasTextInput = true; self.setLinkedTextValue(si, zi, z, e.target.value); self.renderStage(); self.refresh(); }
        });
        if (self.values[k]) input.value = self.values[k];
        (side.zones || []).forEach(function (candidate, candidateIndex) {
          if (candidate.type === 'text' && self.textGroupKey(si, candidateIndex, candidate) === self.textGroupKey(si, zi, z)) {
            self.inputs[self.key(si, candidateIndex)] = input;
          }
        });
        field.appendChild(input);
        // Die gemeinsame Schriftwahl gehört direkt zum Text: einmal unter dem
        // ersten Texteingabefeld und damit vor Foto- oder Symbolfeldern.
        if (!fontPickerPlaced) {
          var fontPicker = self.renderFontPicker();
          if (fontPicker) field.appendChild(fontPicker);
          fontPickerPlaced = true;
        }
      } else if (z.type === 'motif') {
        // Symbol-Auswahl: erlaubte Motive als anklickbare Miniaturen. Das gewählte
        // erscheint live an der platzierten Stelle auf dem Produktbild.
        var row = node('div', { style: 'display:flex;gap:8px;flex-wrap:wrap' });
        var current = self.motifChoice[k] || (z.required ? (((z.choices || [])[0] || {}).url) : null);
        (z.choices || []).forEach(function (c) {
          var btn = node('button', { type: 'button', title: mgLabel(c.name,c,'name') || mgT("Symbol"),
            'aria-pressed': current === c.url ? 'true' : 'false',
            style: 'width:52px;height:52px;border-radius:12px;cursor:pointer;background:#fff center/contain no-repeat;'
              + 'border:2px solid ' + (current === c.url ? '#c72f46' : '#ddd') });
          btn.style.backgroundImage = "url('" + c.url + "')";
          btn.addEventListener('click', function () {
            var deselect = !z.required && self.motifChoice[k] === c.url;
            if (deselect) delete self.motifChoice[k];
            else self.motifChoice[k] = c.url;
            [].forEach.call(row.children, function (b) {
              b.style.borderColor = '#ddd';
              b.setAttribute('aria-pressed', 'false');
            });
            if (!deselect) {
              btn.style.borderColor = '#c72f46';
              btn.setAttribute('aria-pressed', 'true');
            }
            self.renderStage(); self.refresh();
          });
          row.appendChild(btn);
        });
        if (!(z.choices || []).length) {
          field.appendChild(node('span', { style: 'font-size:12px;color:#999' }, [mgT("Keine Symbole hinterlegt.")]));
        }
        field.appendChild(row);
      }
      // Alle konfigurierten Personalisierungsfelder bleiben direkt sichtbar – auch
      // wenn sie optional sind. Nur „Besondere Wünsche" darf im Klappbereich liegen.
      wrap.appendChild(field);
    });
    self.applyFieldErrors();
    return wrap;
  };

  Personalizer.prototype.newUploadToken = function () {
    return 'up' + Date.now().toString(36) + Math.random().toString(36).slice(2, 14) + Math.random().toString(36).slice(2, 10);
  };

  Personalizer.prototype.clientSession = function () {
    try {
      var key = 'mg_upload_session', value = window.localStorage.getItem(key);
      if (!value) {
        value = 'sess' + Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
        window.localStorage.setItem(key, value);
      }
      return value;
    } catch (e) {
      return null;
    }
  };

  Personalizer.prototype.onPhoto = function (si, zi, e) {
    var self = this, file = e.target.files[0];
    if (!file) return;
    var k = self.key(si, zi);
    var photo = { url: '', w: 0, h: 0, ok: false, orderUrl: null, uploadToken: self.newUploadToken(), uploading: true, uploadFailed: false };
    self.photos[k] = photo;
    self.refresh();
    // Sofortige Vorschau aus dem Browser …
    var reader = new FileReader();
    reader.onload = function (ev) {
      var url = ev.target.result, img = new Image();
      img.onload = function () {
        if (self.photos[k] !== photo) return;
        photo.url = url;
        photo.w = img.naturalWidth;
        photo.h = img.naturalHeight;
        photo.ok = Math.min(img.naturalWidth, img.naturalHeight) >= 800;
        if (photo.updateControl) photo.updateControl();
        self.renderStage(); self.refresh();
      };
      img.src = url;
    };
    reader.readAsDataURL(file);
    // … und parallel zum Server, damit die Bestellung das echte Foto bekommt.
    self.uploadPhoto(k, file, photo);
  };

  // Foto in die App laden; die zurückgegebene URL hängt als Positionsmerkmal an der
  // Bestellung, so findet die Werkstatt das Original.
  Personalizer.prototype.uploadPhoto = function (k, file, photo, attempt) {
    var self = this;
    attempt = attempt || 0;

    function applyUpload(d) {
      if (self.photos[k] === photo) {
        photo.orderUrl = d.url || null;
        photo.uploadToken = d.token || photo.uploadToken;
        photo.uploading = false;
        photo.uploadFailed = !photo.orderUrl;
      }
      if (photo.contentHash && photo.orderUrl) {
        self.uploadCache[photo.contentHash] = { url: photo.orderUrl, token: photo.uploadToken };
      }
      if (self.photos[k] === photo && photo.orderUrl) self.writeProps();
      if (self.photos[k] === photo && photo.updateControl) photo.updateControl();
      self.refresh();
    }

    function send() {
      var cached = photo.contentHash && self.uploadCache[photo.contentHash];
      if (cached) {
        applyUpload(cached);
        return;
      }

      var fd = new FormData();
      fd.append('file', file);
      fd.append('locale', (document.documentElement.lang || 'de').toLowerCase().split('-')[0]);
      fd.append('upload_token', photo.uploadToken);
      if (self.handle) fd.append('product_handle', self.handle);
      var clientSession = self.clientSession();
      if (clientSession) fd.append('client_session', clientSession);
      fetch(APP_URL + '/api/storefront/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(applyUpload)
      .catch(function (err) {
        console.warn('[MeinGeschenk] Foto-Upload fehlgeschlagen:', err);
        if (self.photos[k] === photo && attempt < 2) {
          window.setTimeout(function () { self.uploadPhoto(k, file, photo, attempt + 1); }, 1200 * (attempt + 1));
          return;
        }
        if (self.photos[k] === photo) { photo.uploading = false; photo.uploadFailed = true; }
        if (self.photos[k] === photo && photo.updateControl) photo.updateControl();
        self.refresh();
      });
    }

    if (!photo.contentHash && window.crypto && window.crypto.subtle && file.arrayBuffer) {
      file.arrayBuffer().then(function (buffer) {
        return window.crypto.subtle.digest('SHA-256', buffer);
      }).then(function (digest) {
        photo.contentHash = Array.from(new Uint8Array(digest)).map(function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('');
        send();
      }).catch(send);
    } else {
      send();
    }
  };

  Personalizer.prototype.photosUploading = function () {
    var self = this;
    return Object.keys(this.photos).some(function (k) { return self.photos[k] && self.photos[k].uploading; });
  };
  Personalizer.prototype.photosFailed = function () {
    var self = this;
    return Object.keys(this.photos).some(function (k) { return self.photos[k] && self.photos[k].uploadFailed; });
  };

  Personalizer.prototype.renderGroup = function (g) {
    var self = this;
    var wrap = node('div', { style: 'display:grid;gap:5px' });
    var head = node('div', { style: 'font-weight:700;font-size:14px;display:flex;align-items:center' }, [mgLabel(g.label,g)]);
    if (g.required) head.appendChild(reqBadge());
    wrap.appendChild(head);
    if (g.info) wrap.appendChild(node('div', { style: 'font-size:12px;color:#555;background:#f4faf8;padding:7px 10px;border-radius:8px' }, ['ℹ️ ' + mgLabel(g.info,g,'info')]));
    var row = node('div', { style: 'display:flex;flex-wrap:wrap;gap:7px' });
    (g.choices || []).forEach(function (c) {
      var btn = node('button', { type: 'button', style: self.choiceStyle(false) }, []);
      if (g.type !== 'toggle' && c.hex) btn.appendChild(node('span', { style: 'display:inline-block;width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,.25);background:' + c.hex + ';margin-right:7px;vertical-align:middle' }));
      btn.appendChild(document.createTextNode(mgLabel(c.label,c) + (c.price > 0 ? ' +' + Number(c.price).toFixed(2) : '')));
      btn._key = c.key;
      btn.addEventListener('click', function () { self.toggle(g, c.key, row); });
      row.appendChild(btn);
    });
    wrap.appendChild(row);
    return wrap;
  };
  Personalizer.prototype.choiceStyle = function (on) {
    return 'border:1px solid ' + (on ? '#c72f46' : '#ccc') + ';background:' + (on ? '#fff1f3' : '#fff') + ';color:' + (on ? '#c72f46' : '#333') + ';border-radius:10px;padding:8px 12px;cursor:pointer;font-size:14px';
  };
  Personalizer.prototype.fontBtnStyle = function (on, f) {
    return 'border:1px solid ' + (on ? '#c72f46' : '#ccc') + ';background:' + (on ? '#fff1f3' : '#fff') + ';color:' + (on ? '#c72f46' : '#333') +
      ';border-radius:9px;padding:6px 12px;cursor:pointer;font-size:15px;font-family:' + (FONTS[f] || 'inherit');
  };
  Personalizer.prototype.toggle = function (g, key, row) {
    var cur = this.selection[g.key] || [];
    if (cur.indexOf(key) > -1) this.selection[g.key] = cur.filter(function (k) { return k !== key; });
    else if (g.type === 'multi') this.selection[g.key] = cur.concat([key]);
    else this.selection[g.key] = [key];
    var self = this;
    [].forEach.call(row.children, function (b) { b.style.cssText = self.choiceStyle((self.selection[g.key] || []).indexOf(b._key) > -1); });
    this.renderStage();
    this.refresh();
  };

  // Welche Seiten hat der Kunde befüllt? Daran hängt der Aufpreis je Seite.
  Personalizer.prototype.usedSides = function (withoutLive) {
    var self = this;
    return (this.cfg.sides || []).map(function (s, si) { return si; }).filter(function (si) {
      if (!withoutLive && window.MGLiveEditor && window.MGLiveEditor.usedSides(self).indexOf(si) !== -1) return true;
      // Optionale Seiten zählen genau dann, wenn der Kunde sie eingeschaltet hat –
      // so ist der Aufpreis eindeutig und nicht davon abhängig, ob schon getippt wurde.
      if (self.cfg.sides[si].optional) return !!self.sideOn[si];

      return ((self.cfg.sides[si].zones) || []).some(function (z, zi) {
        if (z.type === 'text') return (self.values[self.key(si, zi)] || '').trim() !== '';
        if (z.type === 'photo') return !!self.photos[self.key(si, zi)];
        return false;
      });
    });
  };

  // Schnelle Eingaben bündeln: erst ~250 ms nach dem letzten Tastendruck zum Server.
  Personalizer.prototype.refresh = function () {
    var self = this;
    this._priceSequence = (this._priceSequence || 0) + 1;
    this.valid = false;
    this.setCartEnabled(false);
    this.emitMobileState();
    clearTimeout(this._t);
    this._t = setTimeout(function () { self._refreshNow(); }, 250);
  };
  Personalizer.prototype._refreshNow = function () {
    var self = this;
    var sequence = this._priceSequence;
    var addons = Object.keys(this.addonState).filter(function (i) { return self.addonState[i]; }).map(Number);
    fetch(APP_URL + '/api/storefront/products/' + encodeURIComponent(this.handle) + '/price', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        selection: this.selection,
        addons: addons,
        usedSides: this.usedSides(),
        profile: this.currentProfileKey,
        locale: (document.documentElement.lang || 'de').toLowerCase().split('-')[0]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (sequence !== self._priceSequence) return;
        // Server-Hinweise (z.B. Zeichenlimit) sind spezifisch – die zeigen wir.
        self.serverMsgs = Object.keys(data.errors || {}).map(function (k) { return mgError(data.errors[k]); });
        self.missing = self.missingRequired();
        self.missingCount = self.missing.length;
        self.missingGroups = self.missingRequiredGroups();
        self.uploading = self.photosUploading();
        self.valid = (self.missingCount + self.missingGroups.length + self.serverMsgs.length === 0) && !self.uploading;
        self.emitMobileState();

        self.renderErrorBox();
        self.applyFieldErrors();

        var rows = data.rows || [];
        var extra = rows.filter(function (r) { return r.kind ? r.kind !== 'base' : r.label !== 'Grundpreis'; });
        var sum = function (pred) {
          return rows.filter(pred).reduce(function (s, r) { return s + Number(r.amount || 0); }, 0);
        };

        // Aufpreis-Summe fuer die Anzeige (alles ausser dem Grundpreis).
        self.surchargeAmount = extra.reduce(function (s, r) { return s + Number(r.amount || 0); }, 0);

        // Woher der Aufpreis kommt, entscheidet, WIE er verrechnet wird:
        // Gravur (Seiten/Optionsgruppen) -> Produktvariante,
        // Zusatzoption (z.B. Geschenkbox) -> eigener Artikel im Warenkorb.
        var hatKind = rows.some(function (r) { return !!r.kind; });
        self.engravingAmount = hatKind ? sum(function (r) { return r.kind === 'side' || r.kind === 'group'; }) : self.surchargeAmount;
        self.addonAmount = hatKind ? sum(function (r) { return r.kind === 'addon'; }) : 0;
        self.surchargeBox.innerHTML = extra.length
          ? mgHTML("Aufpreis Personalisierung: <b>") + money(data.currency, self.surchargeAmount) + '</b>'
          : '';
        if (window.MG && MG.setPriceBreakdown) MG.setPriceBreakdown(rows);
        // Total-Anzeige des Themes um den Aufpreis ergänzen (Rappen).
        if (window.MG && MG.setSurcharge) MG.setSurcharge(Math.round(self.surchargeAmount * 100));

        // Wenn der Aufpreis über echte Produkt-Varianten läuft: passende Variante als
        // Warenkorb-ID setzen (ihr Preis enthält den Aufpreis bereits).
        self.applyVariant();

        self.materialBox.style.display = data.needsMaterial ? 'block' : 'none';
        self.materialBox.textContent = mgT("Wir starten die Fertigung, sobald dein Material bei uns ist.");

        // Warenkorb erst freigeben, wenn alle Pflichtfelder ausgefüllt sind – vorher
        // grau, plus ruhiger Hinweis, WAS noch fehlt. So ist klar, dass man erst
        // personalisieren muss, statt ein leeres Produkt bestellen zu können.
        self.updateNeeds();
        self.setCartEnabled(self.valid);
        self.writeProps();
      })
      .catch(function (e) { console.warn('[MeinGeschenk] Preis nicht berechnet:', e); });
  };

  // Aufpreis über eine echte Produkt-Variante: die zum aktuellen Aufpreis passende
  // Variante als Warenkorb-ID setzen. "0" = Standardvariante. Ohne Karte -> nichts tun.
  /** Rappen, die über die Produktvariante abgerechnet werden (nur Gravur-Aufpreise). */
  Personalizer.prototype.engravingCents = function () {
    var a = (this.engravingAmount !== undefined) ? this.engravingAmount : (this.surchargeAmount || 0);

    return Math.round(a * 100);
  };

  /** Aktuell gewählte Farbe (klein) aus dem nativen Swatch – oder null. */
  Personalizer.prototype.selectedColorKey = function () {
    var picks = this._variantPicks || document.getElementById('mgp-variantpicks');
    var active = picks && picks.querySelector('.mgp-swatch.active, .mgp-variant.active');

    return active ? String(active.getAttribute('data-value') || '').toLowerCase() : null;
  };

  /** Im Farb×Aufpreis-Modus die Rappen=>ID-Unterkarte der gewählten Farbe (Rückfall: erste). */
  Personalizer.prototype.colorSubmap = function (map) {
    var key = this.selectedColorKey();
    if (key && map[key]) return map[key];
    var keys = Object.keys(map || {});          // vor dem ersten Klick: erste Farbe

    return keys.length ? map[keys[0]] : null;
  };

  /** Gibt es für den aktuellen Gravur-Aufpreis überhaupt eine Variante? */
  Personalizer.prototype.variantCovers = function () {
    var map = this.cfg && this.cfg.surchargeVariants;
    if (!map) return true;                       // kein Varianten-Modus -> nicht unsere Sache
    var cents = this.engravingCents();

    if (this.cfg.variantColorOption) {           // Farbe × Aufpreis (verschachtelt)
      var sub = this.colorSubmap(map);
      return !!sub && (sub[cents] != null || sub['0'] != null);
    }

    return map[cents] != null;
  };

  Personalizer.prototype.applyVariant = function () {
    var map = this.cfg && this.cfg.surchargeVariants;
    if (!map) return null;
    var cents = this.engravingCents();
    var vid;

    if (this.cfg.variantColorOption) {
      // Verschachtelt: die zur gewählten Farbe UND zum Aufpreis passende Variante.
      var sub = this.colorSubmap(map);
      if (!sub) return null;
      vid = (sub[cents] != null) ? sub[cents] : sub['0'];
    } else {
      vid = (map[cents] != null) ? map[cents] : map['0'];
    }
    if (vid == null) return null;

    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    // Nur den versteckten Wert setzen (kein change-Event) – so bleibt die angezeigte
    // Preisberechnung des Themes bei Farb-Grundpreis + Aufpreis und verdoppelt nichts.
    if (input) input.value = String(vid);
    return String(vid);
  };

  /**
   * Wechselt der Kunde nativ die Farbe, setzt das Theme die Warenkorb-ID auf die
   * Standard-Ausführung dieser Farbe. Danach unsere Aufpreis-Variante neu wählen,
   * damit ein gesetzter Seiten-Aufpreis erhalten bleibt.
   */
  Personalizer.prototype.hookColorChange = function () {
    if (!this.cfg || !this.cfg.variantColorOption) return;
    var self = this;
    document.addEventListener('mg:variant:change', function () { self.applyVariant(); });
  };

  /**
   * Ist diese Seite gerade zu befüllen? Pflichtseiten immer; optionale erst,
   * wenn der Kunde sie dazugewählt hat.
   */
  Personalizer.prototype.sideActive = function (si) {
    var side = (this.cfg && this.cfg.sides || [])[si];
    if (!side) return false;
    if (window.MGLiveEditor && window.MGLiveEditor.usedSides(this).indexOf(si) !== -1) return true;

    return side.optional ? !!this.sideOn[si] : true;
  };

  /** Schalter für eine optionale Seite – inklusive Aufpreis, damit er verkauft. */
  Personalizer.prototype.renderSideToggle = function (side, si) {
    var self = this;
    var preis = Number(side.surcharge || 0);
    var text = (mgLabel(side.label,side) || mgT("Diese Seite")) + mgT(" gravieren")
      + (preis > 0 ? ' (+ ' + money(this.cfg.currency, preis) + ')' : '');

    var cb = node('input', {
      type: 'checkbox',
      onchange: function (e) {
        self.sideOn[si] = e.target.checked;
        self.render();          // Felder ein-/ausblenden
        self.renderStage();
        self.refresh();         // Aufpreis neu rechnen
      },
    });
    if (this.sideOn[si]) cb.checked = true;
    if (window.MGLiveEditor && window.MGLiveEditor.usedSides(this).indexOf(si) !== -1) {
      cb.checked = true;
      cb.disabled = true;
      text += mgT(" · im Live-Editor gestaltet (dort entfernbar)");
    }

    return node('label', {
      style: 'display:flex;gap:9px;align-items:center;font-size:14px;font-weight:700;cursor:pointer;'
        + 'border:1px solid ' + (this.sideOn[si] ? '#c72f46' : '#ddd') + ';border-radius:10px;padding:11px 13px;'
        + 'background:' + (this.sideOn[si] ? '#fff6f7' : '#fff'),
    }, [cb, text]);
  };

  /** Hat die gerade offene Seite überhaupt ein Textfeld? */
  Personalizer.prototype.activeSideHasText = function () {
    if (!this.sideActive(this.activeSide)) return false;

    var side = (this.cfg && this.cfg.sides || [])[this.activeSide];

    return !!(side && (side.zones || []).some(function (z) { return z.type === 'text'; }));
  };

  /**
   * Welche Schriften stehen zur Wahl? Die Schnittmenge aller Textfelder – so bieten
   * wir nie eine Schrift an, die ein Feld gar nicht erlaubt.
   */
  Personalizer.prototype.fontChoices = function () {
    var lists = [];
    (this.cfg && this.cfg.sides || []).forEach(function (s) {
      (s.zones || []).forEach(function (z) {
        if (z.type === 'text' && z.allowedFonts && z.allowedFonts.length) lists.push(z.allowedFonts);
      });
    });
    if (!lists.length) return [];

    var inter = lists[0].filter(function (f) {
      return lists.every(function (l) { return l.indexOf(f) > -1; });
    });

    return inter.length ? inter : lists[0];
  };

  /** Die gewählte Schrift auf alle Textfelder anwenden (die sie erlauben). */
  Personalizer.prototype.setFontForAll = function (f) {
    var self = this;
    this.font = f;
    this.fontSelected = true;
    (this.cfg && this.cfg.sides || []).forEach(function (s, si) {
      (s.zones || []).forEach(function (z, zi) {
        if (z.type !== 'text') return;
        if (!z.allowedFonts || !z.allowedFonts.length || z.allowedFonts.indexOf(f) > -1) {
          self.cfonts[self.key(si, zi)] = f;
        }
      });
    });
  };

  /** EINE Schriftauswahl für das ganze Produkt, statt unter jedem Feld dieselbe. */
  Personalizer.prototype.renderFontPicker = function () {
    var self = this;
    var fonts = this.fontChoices();
    if (fonts.length < 2) return null;   // nichts zu wählen -> gar nicht zeigen

    var wrap = node('div', { style: 'display:grid;gap:6px;margin-top:5px' });
    wrap.appendChild(node('label', { style: 'font-weight:700;font-size:13px' }, [mgT("Schriftart")]));

    var row = node('div', { style: 'display:flex;flex-wrap:wrap;gap:6px' });
    fonts.forEach(function (f) {
      var b = node('button', { type: 'button', style: self.fontBtnStyle(self.font === f, f) }, [FONT_LABELS[f] || f]);
      b.setAttribute('data-f', f);
      b.addEventListener('click', function () {
        self.setFontForAll(f);
        [].forEach.call(row.children, function (x) {
          x.style.cssText = self.fontBtnStyle(x.getAttribute('data-f') === f, x.getAttribute('data-f'));
        });
        self.renderStage();
        self.writeProps();
      });
      row.appendChild(b);
    });

    wrap.appendChild(row);
    wrap.appendChild(node('p', { style: 'font-size:11px;color:#777;margin:2px 0 0' }, [mgT("Gilt für alle Gravurtexte.")]));

    return wrap;
  };

  // Aufklappbarer Foto-Guide (Überschrift, Tipps, Beispielbilder) – wie im alten
  // Editor, aber nur bei Foto-Zonen. Inhalt kommt aus MG.photoGuide (Theme-Einstellung).
  Personalizer.prototype.photoGuideNode = function () {
    var g = (window.MG && MG.photoGuide) || null;
    if (!g || !g.enabled) return null;
    var hasContent = g.heading || g.text || (g.boxes && g.boxes.length);
    if (!hasContent) return null;

    injectGuideStyles();

    var det = node('details', g.open ? { class: 'mg-fg', open: 'open' } : { class: 'mg-fg' });
    det.appendChild(node('summary', { class: 'mg-fg__sum' }, [
      node('span', {}, [mgLabel(g.heading) || mgT("💡 So gelingt dein Foto")]),
      node('span', { class: 'mg-fg__chev' }),
    ]));

    var body = node('div', { class: 'mg-fg__body' });
    if (g.text) {
      var t = node('div', { class: 'mg-fg__text' });
      t.innerHTML = g.text;   // Theme-Einstellung (richtext), vom Händler gepflegt
      body.appendChild(t);
    }
    if (g.boxes && g.boxes.length) {
      var grid = node('div', { class: 'mg-fg__boxes' });
      g.boxes.forEach(function (b) {
        var card = node('div', { class: 'mg-fg__box' });
        if (b.image) card.appendChild(node('img', { src: b.image, alt: '', loading: 'lazy' }));
        else card.appendChild(node('span', { class: 'mg-fg__ph' }, ['📷']));
        if (b.caption) card.appendChild(node('span', { class: 'mg-fg__cap' }, [mgLabel(b.caption)]));
        grid.appendChild(card);
      });
      body.appendChild(grid);
    }
    det.appendChild(body);
    return det;
  };

  // Pflicht-Auswahlgruppen (z. B. Farben bei Epoxy-Produkten) werden lokal
  // geprüft, damit der mobile Button nicht kurz vor der Serverantwort freigibt.
  Personalizer.prototype.missingRequiredGroups = function () {
    var self = this, missing = [];
    (this.cfg && this.cfg.groups || []).forEach(function (group) {
      var chosen = self.selection[group.key] || [];
      var count = chosen.length;
      var min = group.type === 'multi' ? Number(group.min || 0) : 0;
      if ((group.required && count === 0) || (count > 0 && min > 0 && count < min)) {
        missing.push({ key: group.key, label: group.label || mgT("Option"), type: 'option' });
      }
    });
    return missing;
  };

  Personalizer.prototype.missingRequired = function () {
    var self = this, miss = [];
    (this.cfg.sides || []).forEach(function (s, si) {
      // Eine nicht dazugewählte Zusatzseite darf den Kauf nicht blockieren.
      if (!self.sideActive(si)) return;

      (s.zones || []).forEach(function (z, zi) {
        var k = self.key(si, zi);
        if (z.type === 'text' && self.isTextInputOwner(si, zi, z)) {
          var source = self.textSource(si, zi, z);
          if (self.isFieldRequired(si, zi, z) && !(self.values[k] || '').trim()) {
            miss.push({ si: si, zi: zi, label: source.label || 'Text', type: 'text' });
          }
        }
        // Pflicht-Foto: ohne hochgeladenes Bild kein Warenkorb. Eine Foto-Zone gilt
        // als Pflicht, solange sie nicht ausdrücklich abgeschaltet wurde (required:false) –
        // bei Foto-Anhängern wäre eine Bestellung ohne Bild sonst wertlos.
        if (z.type === 'photo' && self.isFieldRequired(si, zi, z) && (!self.photos[k] || !self.photos[k].orderUrl || self.photos[k].uploading || self.photos[k].uploadFailed)) {
          miss.push({ si: si, zi: zi, label: z.label || 'Foto', type: 'photo' });
        }
      });
    });
    return miss;
  };

  // Eine einzige, freundliche Zeile statt jedes fehlenden Feldes einzeln – und erst,
  // wenn der Kunde „In den Warenkorb" gedrückt hat (showErrors).
  Personalizer.prototype.renderErrorBox = function () {
    if (!this.errorBox) return;
    if (!this.showErrors || this.valid) { this.errorBox.style.display = 'none'; return; }

    var lines = [];
    if (this.uploading) lines.push(mgT("Foto wird noch hochgeladen – einen Moment bitte."));
    if (this.photosFailed()) lines.push(mgT("Foto konnte nicht hochgeladen werden. Bitte wähle es nochmals aus."));
    if (this.missingCount) {
      var onlyPhoto = (this.missing || []).every(function (m) { return m.type === 'photo'; });
      lines.push(onlyPhoto
        ? mgT("Bitte lade zuerst dein Foto hoch – ohne Bild können wir nicht gravieren.")
        : mgT("Bitte fülle die rot markierten Pflichtfelder aus."));
    }
    (this.serverMsgs || []).forEach(function (m) { lines.push(m); });

    this.errorBox.textContent = lines.join(' ');
    this.errorBox.style.display = lines.length ? 'block' : 'none';
  };

  // Ruhiger Dauer-Hinweis (vor dem Klick), was noch fehlt – damit der gesperrte
  // Warenkorb-Knopf verständlich ist. Kein Alarm-Rot; das kommt erst beim Klick.
  Personalizer.prototype.updateNeeds = function () {
    if (!this.needsBox) return;
    if (this.valid) { this.needsBox.style.display = 'none'; return; }

    var labels = (this.missing || []).concat(this.missingGroups || []).map(function (m) { return mgLabel(m.label); });
    var lines = [];
    if (this.uploading) lines.push(mgT("Foto wird noch hochgeladen …"));
    if (this.photosFailed()) lines.push(mgT("Foto-Upload fehlgeschlagen. Bitte nochmals auswählen."));
    if (labels.length) lines.push(mgT("Bitte zuerst ausfüllen: ") + labels.join(', ') + '.');
    else if ((this.serverMsgs || []).length) lines.push(mgT("Bitte Eingaben prüfen."));

    this.needsBox.textContent = lines.join(' ');
    this.needsBox.style.display = lines.length ? 'block' : 'none';
  };

  // Leere Pflicht-Textfelder rot umranden – nur nach einem Absende-Versuch.
  Personalizer.prototype.applyFieldErrors = function () {
    var self = this;
    (this.cfg && this.cfg.sides || []).forEach(function (s, si) {
      (s.zones || []).forEach(function (z, zi) {
        var k = self.key(si, zi);

        var inp = self.inputs[k];
        if (inp && z.type === 'text' && self.isTextInputOwner(si, zi, z)) {
          var bad = self.showErrors && self.isFieldRequired(si, zi, z) && !((self.values[k] || '').trim());
          inp.style.borderColor = bad ? '#c0392b' : '#ccc';
          inp.style.background = bad ? '#fff6f5' : '#fff';
        }

        var pill = self.pills[k];
        if (pill) {
          var photo = self.photos[k];
          var hasPhoto = !!photo;
          var badPhoto = !!(photo && photo.uploadFailed) || (self.showErrors && self.isFieldRequired(si, zi, z) && !hasPhoto);
          pill.style.borderColor = badPhoto ? '#c0392b' : (hasPhoto ? '#d9d5d1' : '#cbb9a7');
          pill.style.background = badPhoto ? '#fff6f5' : (hasPhoto ? '#fff' : '#faf6f1');
        }
      });
    });
  };

  // Zum ersten fehlenden Pflichtfeld springen (ggf. Seite wechseln) und hineinfokussieren.
  Personalizer.prototype.focusFirstMissing = function () {
    var miss = this.missingRequired();
    if (!miss.length) return;
    var first = miss[0];
    if (first.si !== this.activeSide) { this.activeSide = first.si; this.render(); }
    var k = this.key(first.si, first.zi);
    // Fehlt ein Pflicht-Foto, zum Foto-Knopf springen – sonst ins Textfeld.
    var el = first.type === 'photo' ? this.pills[k] : this.inputs[k];
    if (!el) return;
    try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    if (el.focus) el.focus();
  };

  Personalizer.prototype.requiredPhotoKeys = function () {
    var self = this, keys = [];
    (this.cfg && this.cfg.sides || []).forEach(function (side, si) {
      if (!self.sideActive(si)) return;
      (side.zones || []).forEach(function (zone, zi) {
        if (zone.type === 'photo' && self.isFieldRequired(si, zi, zone)) keys.push(self.key(si, zi));
      });
    });
    return keys;
  };

  Personalizer.prototype.emitMobileState = function () {
    if (!this.cfg) return;
    var self = this, keys = this.requiredPhotoKeys();
    var hasPhoto = false, hasText = false, hasRequiredText = false;
    (this.cfg.sides || []).forEach(function (side, si) {
      if (!self.sideActive(si)) return;
      (side.zones || []).forEach(function (zone, zi) {
        if (zone.type === 'photo') hasPhoto = true;
        if (zone.type === 'text' && self.isTextInputOwner(si, zi, zone)) {
          hasText = true;
          if (self.isFieldRequired(si, zi, zone)) hasRequiredText = true;
        }
      });
    });
    var missing = this.missingRequired();
    var missingGroups = this.missingRequiredGroups();
    var missingPhoto = missing.some(function (item) { return item.type === 'photo'; });
    var missingText = missing.some(function (item) { return item.type === 'text'; });
    var hasOptions = !!(this.cfg.groups && this.cfg.groups.length);
    var photos = keys.map(function (key) { return self.photos[key]; });
    var uploading = photos.some(function (photo) { return !!(photo && photo.uploading); });
    var failed = photos.some(function (photo) { return !!(photo && photo.uploadFailed); });
    var photoUploaded = keys.length > 0 && photos.every(function (photo) {
      return !!(photo && photo.orderUrl && !photo.uploading && !photo.uploadFailed);
    });
    document.dispatchEvent(new CustomEvent('mg:personalizer:state', { detail: {
      ready: true,
      personalizable: true,
      mode: hasPhoto && hasText ? 'photo_text' : (hasPhoto ? 'photo' : (hasText ? 'text' : (hasOptions ? 'options' : 'none'))),
      hasPhoto: hasPhoto,
      hasText: hasText,
      hasOptions: hasOptions,
      hasRequiredPhoto: keys.length > 0,
      hasRequiredText: hasRequiredText,
      photoUploaded: photoUploaded,
      missingPhoto: missingPhoto,
      missingText: missingText,
      missingOption: missingGroups.length > 0,
      uploading: uploading,
      failed: failed,
      complete: !!this.valid && missingGroups.length === 0
    } }));
  };

  Personalizer.prototype.openPhotoPicker = function () {
    var keys = this.requiredPhotoKeys();
    if (!keys.length) return this.reviewPersonalization();
    if (this.mode() === 'popup') this.openPopup();
    var self = this;
    var key = keys.find(function (candidate) {
      return !self.photos[candidate] || !self.photos[candidate].orderUrl || self.photos[candidate].uploadFailed;
    }) || keys[0];
    var parts = key.split('-'), sideIndex = parseInt(parts[0], 10);
    if (sideIndex !== this.activeSide) { this.activeSide = sideIndex; this.render(); }
    var pill = this.pills[key];
    if (!pill) return;
    try { pill.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    var input = pill.querySelector('input[type="file"]');
    if (input) input.click();
  };

  Personalizer.prototype.openPersonalization = function () {
    if (this.mode() === 'popup') this.openPopup();
    var missing = this.missingRequired();
    if (missing.length) return this.focusFirstMissing();
    var target = this.mode() === 'popup' && this._popupBody ? this._popupBody : this.container;
    try { target.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    var firstControl = target.querySelector('input, textarea, select, button');
    if (firstControl && firstControl.focus) firstControl.focus();
  };

  Personalizer.prototype.reviewPersonalization = function () {
    if (this.mode() === 'popup') this.openPopup();
    var target = this.errorBox || this.container;
    try { target.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    if (!this.valid) {
      this.showErrors = true;
      this.renderErrorBox();
      this.applyFieldErrors();
      this.focusFirstMissing();
    }
  };

  /**
   * Feldname für die Bestellung. Heisst dasselbe Feld auf mehreren Seiten gleich
   * (z.B. nachdem im Panel das Layout der Vorderseite übernommen wurde), wird die
   * Seite vorangestellt – sonst überschriebe die Rückseite die Eingabe der
   * Vorderseite und die Werkstatt sähe nur eine der beiden Gravuren.
   */
  Personalizer.prototype.propName = function (side, zone, fallback) {
    var label = zone.label || fallback;

    if (!this._labelCount) {
      var counts = {};
      (this.cfg.sides || []).forEach(function (s) {
        (s.zones || []).forEach(function (z) {
          var l = z.label || '';
          if (l) counts[l] = (counts[l] || 0) + 1;
        });
      });
      this._labelCount = counts;
    }

    var doppelt = (this.cfg.sides || []).length > 1 && this._labelCount[label] > 1;

    return (doppelt && side.label) ? side.label + ' · ' + label : label;
  };

  // Shopify blendet Positionsmerkmale mit führendem Unterstrich im Checkout aus.
  // So bleibt die Original-URL intern verfügbar, ohne Kunden eine lange technische
  // Adresse zu zeigen. Seite + Zone machen den Namen auch bei mehreren Fotos stabil.
  Personalizer.prototype.photoUrlPropName = function (si, zi) {
    return '_mg_photo_url_' + si + '_' + zi;
  };

  // Auswahl als Shopify-Positionsmerkmale schreiben (Text = Klartext).
  Personalizer.prototype.writeProps = function () {
    var self = this, props = {}, additions = [], hasEnteredText = false;
    (this.cfg.sides || []).forEach(function (s, si) {
      // Abgewählte Zusatzseite: nichts davon gehört auf die Bestellung.
      if (!self.sideActive(si)) return;
      if (s.optional) additions.push((s.label || ('Seite ' + (si + 1))) + ' gravieren');

      (s.zones || []).forEach(function (z, zi) {
        var k = self.key(si, zi);
        if (z.type === 'text' && self.isTextInputOwner(si, zi, z) && (self.values[k] || '').trim()) {
          var source = self.textSource(si, zi, z);
          putProp(props, self.propName(s, source, 'Gravur'), self.values[k]);
          hasEnteredText = true;
        }
        if (z.type === 'photo' && self.photos[k]) {
          var ph = self.photos[k];
          // Im Checkout nur eine freundliche Bestätigung zeigen. Die echte URL
          // bleibt als ausgeblendetes Merkmal für Warenkorb, Bearbeitung und Werkstatt.
          putProp(props, self.propName(s, z, 'Foto'), ph.uploading ? 'Wird hochgeladen …' : 'Erfolgreich hochgeladen');
          if (ph.orderUrl) props[self.photoUrlPropName(si, zi)] = ph.orderUrl;
        }
        if (z.type === 'motif' && (z.choices || []).length) {
          // Nur eine echte Auswahl (oder der Pflicht-Standard) landet in der Bestellung.
          var murl = self.motifChoice[k] || (z.required ? z.choices[0].url : null);
          if (murl) {
            var ch = z.choices.find(function (c) { return c.url === murl; });
            putProp(props, self.propName(s, z, 'Symbol'), (ch && ch.name) || 'Symbol');
          }
        }
      });
    });
    if (this.profiles.length > 1 && this.currentProfileKey) {
      var currentProfile = this.profiles.find(function (profile) { return profile.key === self.currentProfileKey; });
      if (currentProfile) {
        props['Produkt-Look'] = currentProfile.name;
        props['_mg_profile_key'] = currentProfile.key;
      }
    }
    // Die Vorschau verwendet immer eine Standardschrift. In die Bestellung gehört
    // sie aber nur, wenn Text vorhanden ist und der Kunde sie bewusst gewählt hat.
    if (hasEnteredText && this.fontSelected && this.font && this.fontChoices().length > 1) {
      props['Schrift'] = FONT_LABELS[this.font] || this.font;
    }

    (this.cfg.groups || []).forEach(function (g) {
      var chosen = (self.selection[g.key] || []).map(function (key) {
        var c = (g.choices || []).find(function (x) { return x.key === key; });
        return c ? c.label : key;
      });
      if (chosen.length) props[g.label] = chosen.join(', ');
    });
    Object.keys(this.addonState).forEach(function (i) {
      if (!self.addonState[i]) return;
      var addon = self.cfg.addons[i] || {};
      var label = addon.label || 'Zusatzoption';
      props[label] = 'Ja';
      additions.push(label);
    });

    var uploadTokens = this.uploadTokens();
    if (uploadTokens.length) props['_mg_uploads'] = uploadTokens.join(',');
    if (additions.length) props['_mg_zusatzleistungen'] = additions.join(' | ');
    // Freitext-Wunsch an die Bestellung hängen (erscheint im Panel + am Produktionsauftrag).
    if (this.specialWish && this.specialWish.trim()) props['Besondere Wünsche'] = this.specialWish.trim();
    if (window.MGLiveEditor) window.MGLiveEditor.properties(this, props);
    this.setProperties(props);
  };

  Personalizer.prototype.uploadTokens = function () {
    var self = this;
    var tokens = Object.keys(this.photos || {}).map(function (key) {
      return self.photos[key] && self.photos[key].uploadToken;
    }).filter(Boolean);

    if (!tokens.length && this.editOriginalProperties && this.editOriginalProperties['_mg_uploads']) {
      tokens = String(this.editOriginalProperties['_mg_uploads']).split(',').map(function (token) { return token.trim(); }).filter(Boolean);
    }

    if (window.MGLiveEditor) tokens = tokens.concat(window.MGLiveEditor.tokens(this));
    return tokens.filter(function (token, index) { return tokens.indexOf(token) === index; });
  };

  /**
   * Angehakte Zusatzoptionen, die einen eigenen Artikel haben (z.B. Geschenkbox).
   * Die kommen als separate Warenkorb-Zeile – so bleiben Lagerbestand und
   * Auswertung sauber, statt sie in eine Preisvariante zu quetschen.
   */
  Personalizer.prototype.checkAddonAvailability = function () {
    var self = this, products = {};
    return Promise.all((this.cfg.addons || []).map(function (a, i) {
      if (!a.productHandle || !a.variantId) return Promise.resolve();
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      if (!products[a.productHandle]) products[a.productHandle] = fetch(root + 'products/' + encodeURIComponent(a.productHandle) + '.js')
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); });
      return products[a.productHandle].then(function (product) {
        var variant = (product.variants || []).filter(function (v) { return String(v.id) === String(a.variantId); })[0];
        a.available = !!(variant && variant.available);
      }).catch(function () { a.available = false; a.stockUnknown = true; }).then(function () {
        if (!a.available) self.addonState[i] = false;
        var label = a._stockLabel;
        if (label) {
          var cb = label.querySelector('input');
          cb.disabled = !a.available;
          cb.checked = !!self.addonState[i];
          label.lastChild.textContent = mgLabel(a.label,a) + (a.available ? ' (+ ' + money(self.cfg.currency, a.price) + ')' : (a.stockUnknown ? mgT(" – Zurzeit nicht verfügbar") : mgT(" – Zurzeit ausverkauft")));
        }
        self.refresh();
      });
    }));
  };

  Personalizer.prototype.addonItems = function () {
    var self = this, items = [], seen = {};
    Object.keys(this.addonState).forEach(function (i) {
      if (!self.addonState[i]) return;
      var a = (self.cfg.addons || [])[i];
      if (a && a.variantId && !seen[String(a.variantId)]) {
        seen[String(a.variantId)] = true;
        items.push({ id: a.variantId, label: a.label || mgT("Option") });
      }
    });

    return items;
  };

  /**
   * Kostenpflichtige Zusatzoptionen ohne Shopify-Artikel dürfen nie nur als
   * Positionsmerkmal durchrutschen – sonst steht z.B. „Geschenkbox: Ja" am
   * Auftrag, obwohl dafür nichts verrechnet wurde.
   */
  Personalizer.prototype.unbillableAddons = function () {
    var self = this, labels = [];
    Object.keys(this.addonState).forEach(function (i) {
      if (!self.addonState[i]) return;
      var a = (self.cfg.addons || [])[i];
      if (a && (a.available === false || (a.productHandle && a.available === undefined) || (Number(a.price || 0) > 0 && !a.variantId))) labels.push(a.label || mgT("Zusatzoption"));
    });

    return labels;
  };

  Personalizer.prototype.showCartError = function (message) {
    this.showErrors = true;
    if (this.errorBox) {
      this.errorBox.textContent = message;
      this.errorBox.style.display = 'block';
      if (this.errorBox.scrollIntoView) this.errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var button = document.getElementById('mgp-cart');
    if (button) {
      button.disabled = false;
      button.textContent = this.editLineKey ? mgT("Änderungen speichern") : mgT("In den Warenkorb");
    }
  };

  /** Hauptartikel + Zusatzoptionen gemeinsam per AJAX in den Warenkorb legen. */
  Personalizer.prototype.submitWithAddons = function (e, form, surcharge) {
    var self = this;
    e.preventDefault();
    e.stopImmediatePropagation();

    var mainId = (form.querySelector('[name="id"]') || {}).value;
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;

    var props = {};
    [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function (i) {
      var m = i.name.match(/^properties\[(.+)\]$/);
      if (m && i.value) props[m[1]] = i.value;
    });

    // Ein generischer Gravur-Aufpreis darf mit dem Hauptartikel gruppiert werden;
    // die Geschenkbox bleibt bewusst eine eigene Warenkorbposition.
    var group = surcharge ? 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8) : null;
    if (group) props['_mg_group'] = group;
    var items = [{ id: mainId, quantity: qty, properties: props }];
    if (surcharge) {
      items.push({
        id: surcharge.id,
        quantity: surcharge.units * qty,
        properties: {
          'Aufpreis für': props['Gravurtext'] || props['Name'] || mgT("Personalisierung"),
          '_mg_group': group,
          '_mg_surcharge': '1'
        }
      });
    }
    this.addonItems().forEach(function (a) {
      items.push({ id: a.id, quantity: qty, properties: { 'Gehört zu': props['Gravurtext'] || props['Name'] || mgT("Personalisierung") } });
    });

    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw r.status; window.location.href = '/cart'; })
      .catch(function (err) {
        // Auf keinen Fall auf form.submit() zurückfallen: Das würde nur den
        // Hauptartikel bestellen und die gewählte Zusatzoption gratis vormerken.
        console.warn('[MeinGeschenk] Warenkorb mit Zusatzoption fehlgeschlagen:', err);
        self.showCartError(mgT("Die gewählte Zusatzoption konnte nicht verrechnet werden. Bitte versuche es nochmals oder melde dich kurz bei uns."));
      });
  };

  // Warenkorb-Absenden abfangen: gibt es einen Aufpreis UND ist ein Aufpreis-Artikel
  // hinterlegt, legen wir Hauptartikel + Aufpreis-Artikel (passende Menge) per AJAX
  // zusammen in den Warenkorb. Ohne Aufpreis läuft der normale Formular-Versand.
  Personalizer.prototype.hookCartForm = function () {
    var self = this;
    // Pflichtfeld-Sperre ganz vorne (Capture auf document): läuft vor jedem Handler
    // am Formular – auch vor einem eigenen AJAX-Warenkorb des Themes.
    if (!document._mgValidateHook) {
      document._mgValidateHook = true;
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
        if (self.valid) return;

        e.preventDefault();
        e.stopPropagation();
        self.showErrors = true;
        self.renderErrorBox();
        self.applyFieldErrors();
        self.focusFirstMissing();
      }, true);
    }

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form._mgSurchargeHook) return;
    form._mgSurchargeHook = true;

    if (self.editLineKey) {
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) qtyInput.value = self.editQuantity || 1;

      form.addEventListener('submit', function (e) {
        if (!self.valid) return;
        var unbillable = self.unbillableAddons();
        if (unbillable.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.showCartError(unbillable.join(', ') + mgT(" ist gerade nicht bestellbar. Bitte melde dich kurz bei uns – wir richten das sofort ein."));
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        if (self.editSubmitting) return;
        self.editSubmitting = true;

        var saveButton = document.getElementById('mgp-cart');
        if (saveButton) {
          saveButton.disabled = true;
          saveButton.textContent = mgT("Änderungen werden gespeichert …");
        }

        if (self.cfg && self.cfg.surchargeVariants) {
          if (!self.variantCovers()) {
            self.editSubmitting = false;
            if (saveButton) { saveButton.disabled = false; saveButton.textContent = mgT("Änderungen speichern"); }
            return;
          }
          self.applyVariant();
        }

        // Unmittelbar vor dem Speichern die aktuellen Editor-Angaben schreiben.
        // Das ist besonders wichtig, wenn gerade ein neues Foto den alten Link ersetzt hat.
        self.writeProps();

        var mainId = (form.querySelector('[name="id"]') || {}).value;
        var quantity = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;
        var props = {};
        [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function (input) {
          var match = input.name.match(/^properties\[(.+)\]$/);
          if (match && input.value) props[match[1]] = input.value;
        });
        var items = [{ id: mainId, quantity: quantity, properties: props }];
        self.addonItems().forEach(function (addon) { items.push({ id: addon.id, quantity: quantity, properties: { 'Gehört zu': props.Gravurtext || props.Name || mgT("Personalisierung") } }); });

        // Erst erfolgreich hinzufügen, dann die alte Zeile über ihren stabilen
        // Schlüssel ersetzen. Bei einem ausverkauften Zusatz bleibt sie erhalten.
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (response) { if (!response.ok) throw response.status; return response.json(); })
          .then(function (added) {
            var main = (added.items || [added])[0];
            var remaining = main && main.key === self.editLineKey ? quantity : 0;
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: self.editLineKey, quantity: remaining }) });
          })
          .then(function (response) { if (!response.ok) throw response.status; sessionStorage.removeItem('mg_cart_edit'); window.location.href = '/cart'; })
          .catch(function (error) {
            console.warn('[MeinGeschenk] Bearbeiten fehlgeschlagen:', error);
            self.editSubmitting = false;
            if (saveButton) { saveButton.disabled = false; saveButton.textContent = mgT("Änderungen speichern"); }
            window.alert(mgT("Die Änderungen konnten noch nicht gespeichert werden. Bitte versuche es gleich nochmals."));
          });
      }, true);
    }

    form.addEventListener('submit', function (e) {
      // Pflichtfelder erst beim Klick prüfen – dann eine dezente Meldung + Feld-Markierung,
      // statt den Kunden von Anfang an mit rotem Text zu erschlagen.
      if (!self.valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        self.showErrors = true;
        self.renderErrorBox();
        self.applyFieldErrors();
        self.focusFirstMissing();
        return;
      }

      var unbillable = self.unbillableAddons();
      if (unbillable.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        self.showCartError(unbillable.join(', ') + mgT(" ist gerade nicht bestellbar. Bitte melde dich kurz bei uns – wir richten das sofort ein."));
        return;
      }

      // Aufpreis über echte Produkt-Variante? Dann ist der Gravur-Preis schon in der
      // Variante enthalten. Zusatzoptionen kommen als eigene Zeilen dazu.
      if (self.cfg && self.cfg.surchargeVariants) {
        // Sicherheitsnetz: gibt es fuer den Gravur-Aufpreis keine passende Variante,
        // wuerde stillschweigend zu wenig berechnet. Lieber abbrechen und melden.
        if (!self.variantCovers()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.showErrors = true;
          if (self.errorBox) {
            self.errorBox.textContent = mgT("Diese Kombination ist gerade nicht bestellbar. Bitte melde dich kurz bei uns – wir richten das sofort ein.");
            self.errorBox.style.display = 'block';
          }
          console.warn('[MeinGeschenk] Keine Variante fuer Aufpreis', self.engravingCents(), self.cfg.surchargeVariants);

          return;
        }

        self.applyVariant();
        if (self.addonItems().length) { self.submitWithAddons(e, form); }

        return;
      }

      var amt = (self.engravingAmount !== undefined) ? self.engravingAmount : (self.surchargeAmount || 0);
      var vid = self.cfg && self.cfg.surchargeVariantId;
      var unit = (self.cfg && self.cfg.surchargeUnit) || 1;
      var addonItems = self.addonItems();

      // Auch Produkte ohne Aufpreis-Varianten bekommen echte Zusatzartikel. Falls
      // zusätzlich ein Gravur-Aufpreis anfällt, alles atomar gemeinsam hinzufügen.
      if (addonItems.length) {
        if (amt > 0 && !vid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.showCartError(mgT("Der Personalisierungs-Aufpreis kann gerade nicht verrechnet werden. Bitte melde dich kurz bei uns."));
          return;
        }
        self.submitWithAddons(e, form, amt > 0 ? { id: vid, units: Math.round(amt / unit) } : null);
        return;
      }

      if (amt > 0 && !vid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        self.showCartError(mgT("Der Personalisierungs-Aufpreis kann gerade nicht verrechnet werden. Bitte melde dich kurz bei uns."));
        return;
      }

      if (!(amt > 0 && vid)) return;   // nichts zu verrechnen -> normaler Versand

      e.preventDefault();
      var mainId = (form.querySelector('[name="id"]') || {}).value;
      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;

      var props = {};
      [].forEach.call(form.querySelectorAll('input[name^="properties["]'), function (i) {
        var m = i.name.match(/^properties\[(.+)\]$/);
        if (m && i.value) props[m[1]] = i.value;
      });

      var units = Math.round(amt / unit);
      // Gemeinsames verstecktes Token, damit die Cart-Transform-Function Hauptartikel +
      // Aufpreis-Artikel zu einer Zeile zusammenfassen kann. Führendes „_" = im Warenkorb ausgeblendet.
      var group = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      props['_mg_group'] = group;
      var items = [{ id: mainId, quantity: qty, properties: props }];
      if (units > 0) items.push({ id: vid, quantity: units * qty, properties: { 'Aufpreis für': props['Gravurtext'] || props['Name'] || mgT("Personalisierung"), '_mg_group': group, '_mg_surcharge': '1' } });

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r.status; window.location.href = '/cart'; })
        .catch(function (err) {
          // Auch beim Gravur-Aufpreis nicht gratis weiterbestellen, wenn Shopify
          // den abrechnenden Artikel ablehnt.
          console.warn('[MeinGeschenk] Aufpreis-Artikel fehlgeschlagen:', err);
          self.showCartError(mgT("Der Personalisierungs-Aufpreis konnte nicht verrechnet werden. Bitte versuche es nochmals oder melde dich kurz bei uns."));
        });
    });
  };

  // ---- Startpunkte -----------------------------------------------------------

  function bootWithMG() {
    if (!window.MG || !MG.slots || !MG.slots.personalizer || !MG.product) return false;
    MG.personalizer = new Personalizer({
      container: MG.slots.personalizer,
      handle: MG.product.handle,
      setProperties: function (p) { MG.setProperties(p); },
      setCartEnabled: function (ok) {
        var btn = document.getElementById('mgp-cart');
        if (btn) {
          // Einmaliger „Pop", wenn der Knopf gerade von gesperrt -> frei wechselt.
          if (ok && btn.disabled) {
            btn.classList.add('mgp-cart--pop');
            setTimeout(function () { btn.classList.remove('mgp-cart--pop'); }, 550);
          }
          btn.disabled = !ok;
          btn.style.opacity = '';   // Farbe/Zustand steuert jetzt das CSS ([disabled] = grau)
        }
      },
      onReady: function () { if (MG.registerPersonalizer) MG.registerPersonalizer({ source: 'app' }); }
    });
    return true;
  }

  function bootStandalone() {
    document.querySelectorAll('[data-meingeschenk-personalizer]').forEach(function (root) {
      if (root._mgBooted) return;
      root._mgBooted = true;
      var form = root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      new Personalizer({
        container: root,
        handle: root.dataset.handle,
        setProperties: function (props) {
          if (!form) return;
          form.querySelectorAll('input[data-mg="1"]').forEach(function (n) { n.remove(); });
          Object.keys(props).forEach(function (k) {
            form.appendChild(node('input', { type: 'hidden', name: 'properties[' + k + ']', value: String(props[k]), 'data-mg': '1' }));
          });
        },
        setCartEnabled: function (ok) {
          if (!form) return;
          var btn = form.querySelector('[type="submit"], [name="add"]');
          if (btn) { btn.disabled = !ok; btn.style.opacity = ok ? '' : '0.5'; }
        }
      });
    });
  }

  function boot() { if (!bootWithMG()) bootStandalone(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('mg:ready', boot);
})();
